"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[70372],{

/***/ 86010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export clsx */
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["Z"] = (clsx);

/***/ }),

/***/ 57788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n  margin: ",
        ";\n  ",
        "\n  & > img {\n    background: ",
        ";\n    width: ",
        ";\n    height: ",
        ";\n    border-radius: 50%;\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var avatarSize = {
    "x-small": "30px",
    small: "40px",
    medium: "50px",
    large: "70px",
    "x-large": "100px",
    "xx-large": "120px"
};
/* harmony default export */ __webpack_exports__["Z"] = (styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        size: props.size || "100%",
        padding: props.padding || 0,
        margin: props.margin || 0
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-a4069f0d-0"
})(_templateObject1(), function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lowgray */ .Z.lowgray, function(props) {
    return avatarSize[props.size];
}, function(props) {
    return avatarSize[props.size];
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].component */ .Z.component));


/***/ }),

/***/ 81190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32808);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-checkbox-checked .ant-checkbox-inner {\n      background-color: unset;\n      border-color: ",
        ";\n    }\n\n    .ant-checkbox-checked .ant-checkbox-inner::after {\n      border-color: ",
        ";\n      border-width: 1px;\n    }\n\n    .ant-checkbox-input:focus + .ant-checkbox-inner {\n      border-color: ",
        ";\n    }\n\n    :hover .ant-checkbox-inner {\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-checkbox-checked .ant-checkbox-inner {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n\n    :hover .ant-checkbox-inner,\n    .ant-checkbox-input:focus + .ant-checkbox-inner {\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: ",
        ";\n  width: ",
        ";\n\n  .ant-checkbox-checked::after {\n    content: unset;\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var checkboxTheme = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].black */ .Z.black, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro),
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary)
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        height: props.height,
        width: props.width,
        checkboxType: props.checkboxType,
        centered: props.centered
    };
}).withConfig({
    componentId: "sc-155ef71a-0"
})(_templateObject3(), function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var checkboxType = param.checkboxType;
    return checkboxTheme[checkboxType];
}, function(param) {
    var centered = param.centered;
    return centered && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2());
}));


/***/ }),

/***/ 37949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  background: url(",
        ") center center/ ",
        " auto no-repeat;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = (styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        icon: props.icon || "",
        iconSize: props.iconSize || "12px",
        padding: props.padding || "unset",
        width: props.width || "12px",
        height: props.height || "12px",
        margin: props.margin || "unset"
    };
}).withConfig({
    componentId: "sc-8b5a1fc1-0"
})(_templateObject(), function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var iconSize = param.iconSize;
    return iconSize;
}, function(param) {
    var iconSize = param.iconSize;
    return iconSize;
}, function(param) {
    var icon = param.icon;
    return icon;
}, function(param) {
    var iconSize = param.iconSize;
    return iconSize;
}));


/***/ }),

/***/ 10567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97751);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-card-body {\n    padding: 20px;\n  }\n\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Box = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-3a0d262d-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
/* harmony default export */ __webpack_exports__["Z"] = (Box);


/***/ }),

/***/ 30079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T3": function() { return /* binding */ Page; },
/* harmony export */   "V3": function() { return /* binding */ privacyPageTheme; }
/* harmony export */ });
/* unused harmony export Theme */
var theme = {};
var Theme;
(function(Theme) {
    Theme["dark"] = "dark";
    Theme["light"] = "light";
})(Theme || (Theme = {}));
var Page;
(function(Page) {
    Page["privacyDark"] = "privacy-page-dark";
    Page["privacyLight"] = "privacy-page-light";
})(Page || (Page = {}));
var privacyPageTheme = {
    dark: {
        page: Page.privacyDark,
        textPrimary: "#cbcbcb",
        textSecondary: "#858585",
        backgroundPrimary: "#121212",
        backgroundSecondary: "#121212",
        borderPrimary: "#121212"
    },
    light: {
        page: Page.privacyLight,
        textPrimary: "#333333",
        textSecondary: "#858585",
        backgroundPrimary: "#ffffff",
        backgroundSecondary: "#f2f2f2",
        borderPrimary: "#dadada"
    }
};

/* harmony default export */ __webpack_exports__["ZP"] = (theme);


/***/ }),

/***/ 28635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ TrendingTimeFrame; }
/* harmony export */ });
var TrendingTimeFrame;
(function(TrendingTimeFrame) {
    TrendingTimeFrame["ALL"] = "TIME_FRAME_ALL";
    TrendingTimeFrame["ONE_WEEK"] = "TIME_FRAME_1W";
    TrendingTimeFrame["ONE_MONTH"] = "TIME_FRAME_1M";
})(TrendingTimeFrame || (TrendingTimeFrame = {}));


/***/ }),

/***/ 62708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ guest; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/DocumentLayout/index.tsx + 2 modules
var DocumentLayout = __webpack_require__(91646);
// EXTERNAL MODULE: ./src/global/HomePageLayout/index.tsx + 10 modules
var HomePageLayout = __webpack_require__(22647);
// EXTERNAL MODULE: ./src/global/NotFound/styled.ts
var styled = __webpack_require__(64355);
// EXTERNAL MODULE: ./src/global/NotFound/index.tsx
var NotFound = __webpack_require__(79136);
;// CONCATENATED MODULE: ./src/global/NotFound/GuestNotFound.tsx




var GuestNotFound = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageLayout["default"], {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound["default"], {})
        })
    });
};
/* harmony default export */ var NotFound_GuestNotFound = (GuestNotFound);

// EXTERNAL MODULE: ./src/global/StreamWidget/Post/index.tsx + 1 modules
var Post = __webpack_require__(3841);
// EXTERNAL MODULE: ./src/features/post-detail/styled.ts
var post_detail_styled = __webpack_require__(35497);
;// CONCATENATED MODULE: ./src/features/post-detail/guest.tsx





var GuestPostDetail = function(param) {
    var post = param.post;
    if (!post) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound_GuestNotFound, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentLayout/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(post_detail_styled/* GuestPostWrapper */.K, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Post/* default */.Z, {
                post: post,
                showLatestComment: false,
                hasFollowingActivity: false,
                isSinglePost: true,
                entryPoint: "detail"
            })
        })
    });
};
/* harmony default export */ var guest = (GuestPostDetail);


/***/ }),

/***/ 91646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_DocumentLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/statics/Box.js
var Box = __webpack_require__(10567);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/config/theme.ts
var config_theme = __webpack_require__(30079);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
;// CONCATENATED MODULE: ./src/global/DocumentLayout/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n\n  a {\n    color: ",
        ";\n    text-decoration: none;\n    margin: 8px 4px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 10px;\n  min-height: 100vh;\n\n  ",
        "\n\n  @media ",
        " {\n    padding: 20px 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n\n  @media ",
        " {\n    justify-content: space-between;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7cedde8-0"
})(_templateObject(), color/* default.highempahis */.Z.highempahis, function(param) {
    var theme = param.theme;
    if (theme.page === config_theme/* Page.privacyDark */.T3.privacyDark) {
        return " \n        color: ".concat(theme.textPrimary, ";\n        background: ").concat(theme.backgroundSecondary, ";\n        \n        div {\n          background: ").concat(theme.backgroundSecondary, ";\n        }\n\n        a {\n          color: ").concat(theme.textPrimary, ";\n        }\n      ");
    }
    return "";
});
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7cedde8-1"
})(_templateObject1(), color/* default.whiteSmoke */.Z.whiteSmoke, function(param) {
    var theme = param.theme;
    if (theme.page === config_theme/* Page.privacyDark */.T3.privacyDark) {
        return " \n      background: ".concat(theme.backgroundSecondary, ";\n      \n      div {\n        background: ").concat(theme.backgroundSecondary, ";\n      }\n\n      h1, h2, h3, ol, li, p {\n        color: ").concat(theme.textPrimary, ";\n      }\n\n      .ant-card-bordered {\n        border: 1px solid #333333;\n      }\n    ");
    }
    return "";
}, device/* default.tablet */.Z.tablet);
var Header = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a7cedde8-2"
})(_templateObject2(), device/* default.tablet */.Z.tablet);


;// CONCATENATED MODULE: ./src/global/DocumentLayout/__tests__/constant.ts
var DATA_CY_DOCUMENT_LAYOUT = "document-layout";

;// CONCATENATED MODULE: ./src/global/DocumentLayout/index.tsx














var DocumentLayout = function(param) {
    var children = param.children, _noBox = param.noBox, noBox = _noBox === void 0 ? false : _noBox, _noAuth = param.noAuth, noAuth = _noAuth === void 0 ? false : _noAuth, _className = param.className, className = _className === void 0 ? "" : _className;
    var date = new Date();
    var year = date.getFullYear();
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var customPageTheme = theme;
    var stockbitLogo = (0,react.useMemo)(function() {
        return customPageTheme.page === config_theme/* Page.privacyDark */.T3.privacyDark ? "/images/stockbit-white.svg" : "/images/stockbit.svg";
    }, [
        customPageTheme.page
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: className,
        "data-cy": DATA_CY_DOCUMENT_LAYOUT,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                align: "center",
                direction: "row",
                justify: "space-between",
                // @ts-expect-error
                mx: "auto",
                p: "20px 10px",
                style: {
                    maxWidth: "930px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                id: "header-stockbit-logo",
                                src: stockbitLogo,
                                height: "40px",
                                alt: "Stockbit"
                            })
                        })
                    }),
                    !noAuth && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        direction: "row",
                        justify: "center",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/login",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        type: "borderless",
                                        mr: "16px",
                                        mt: "8px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            weight: "bold",
                                            family: "bold",
                                            color: color/* default.pinkSwan */.Z.pinkSwan,
                                            children: "Login"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/register",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        type: "primary",
                                        mt: "8px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            family: "bold",
                                            color: "#fff",
                                            children: "Register"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                mx: "auto",
                mb: "24px",
                style: {
                    maxWidth: "930px"
                },
                children: noBox ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    style: {
                        width: "100%"
                    },
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
                    children: [
                        "2013-",
                        year,
                        " Stockbit \xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/about",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "About"
                            })
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/contact",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "Contact"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://help.stockbit.com/id",
                            children: "Help"
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/rules",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "House Rules"
                            })
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/terms",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "Terms"
                            })
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/privacy",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "Privacy"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
DocumentLayout.propTypes = {
    children: (prop_types_default()).node.isRequired,
    noBox: (prop_types_default()).bool,
    noAuth: (prop_types_default()).bool
};
DocumentLayout.defaultProps = {
    noBox: false,
    noAuth: false
};
/* harmony default export */ var global_DocumentLayout = (DocumentLayout);


/***/ }),

/***/ 79136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var assets_base64icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54392);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(579);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64355);









function NotFound() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_7__/* .PageWrapper */ .FE, {
        "data-cy": "global-not-found",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                src: assets_base64icon__WEBPACK_IMPORTED_MODULE_8__/* .stockbitIcon */ .aq,
                alt: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                direction: "column",
                width: "calc(100% - 250px)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        as: "h1",
                        weight: "700",
                        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].nightRider */ .Z.nightRider,
                        size: "64px",
                        children: "Oops."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].nightRider */ .Z.nightRider,
                        size: "16px",
                        children: 'This page does not exist. So you got lost. It"s ok. You should probably be safer to return to home.'
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                        href: "/stream",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                children: "Back To Home"
                            })
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (NotFound);


/***/ }),

/***/ 79030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ MAX_FILE_SIZE_MB; },
/* harmony export */   "EZ": function() { return /* binding */ IMAGE_TYPE_COMMON; },
/* harmony export */   "Jo": function() { return /* binding */ MAX_IMAGE_SIZE_MB; },
/* harmony export */   "Tb": function() { return /* binding */ MAX_FILE_SIZE; },
/* harmony export */   "Wk": function() { return /* binding */ initialTargetPrice; },
/* harmony export */   "ZX": function() { return /* binding */ COMPOSE_MODE; },
/* harmony export */   "fg": function() { return /* binding */ initialPolling; },
/* harmony export */   "l2": function() { return /* binding */ COMMENT_SETTING_LIST; },
/* harmony export */   "n0": function() { return /* binding */ MAX_IMAGE_SIZE; },
/* harmony export */   "ox": function() { return /* binding */ ALLOWED_DOC_EXT; },
/* harmony export */   "p$": function() { return /* binding */ IMAGE_TYPE_GIF; },
/* harmony export */   "vS": function() { return /* binding */ ADMIN_USER_PRIVILEGE; }
/* harmony export */ });
var ALLOWED_DOC_EXT = [
    ".pdf",
    ".doc",
    ".docx",
    ".xls",
    ".xlsx",
    ".ppt",
    ".pptx",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpointtd",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation", 
];
// max file size: 0MB
var MAX_FILE_SIZE_MB = 10;
var MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
var MAX_IMAGE_SIZE_MB = 2;
var MAX_IMAGE_SIZE = MAX_IMAGE_SIZE_MB * 1024 * 1024;
var COMPOSE_MODE = {
    COMPOSE: "compose",
    EDIT: "edit",
    REPOST: "repost",
    SHARE: "share",
    SHARE_TEXT: "share-link"
};
var initialPolling = {
    isOpen: false,
    duration: {
        Days: 1,
        Hours: 0,
        Mins: 0
    },
    polling_pin: 0,
    polling_options: [
        {
            id: 1,
            value: ""
        },
        {
            id: 2,
            value: ""
        }, 
    ],
    polling_end: 0
};
var initialTargetPrice = {
    isOpen: false,
    target_duration: "7",
    target_price: 0,
    target_symbol: ""
};
var IMAGE_TYPE_GIF = "GIF";
var IMAGE_TYPE_COMMON = "COMMON";
var COMMENT_SETTING_LIST = [
    {
        id: 1,
        label: "Everyone",
        type: "COMMENTER_TYPE_EVERYONE",
        icon: "comment-globe.svg"
    },
    {
        id: 2,
        label: "Only people you follow",
        type: "COMMENTER_TYPE_FOLLOWING",
        icon: "comment-people.svg"
    },
    {
        id: 3,
        label: "Only people you mention",
        type: "COMMENTER_TYPE_MENTION",
        icon: "comment-mention.svg"
    },
    {
        id: 4,
        label: "Only you",
        type: "COMMENTER_TYPE_ONLY_YOU",
        icon: "comment-private.svg"
    }, 
];
var ADMIN_USER_PRIVILEGE = [
    "1",
    "2",
    "4"
];



/***/ }),

/***/ 41351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BT": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_REPORT; },
/* harmony export */   "D6": function() { return /* binding */ DATA_CY_USER_CATEGORY_IDEAS; },
/* harmony export */   "EJ": function() { return /* binding */ DATA_CY_NAME_NEWS_HEADER_MENU; },
/* harmony export */   "En": function() { return /* binding */ DATA_CY_USER_CATEGORY_CHARTS; },
/* harmony export */   "Js": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_ALL; },
/* harmony export */   "LO": function() { return /* binding */ DATA_CY_USER_CATEGORY_SAVED; },
/* harmony export */   "MF": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_ACTIVE; },
/* harmony export */   "Me": function() { return /* binding */ DATA_CY_USER_CATEGORY_LIKED; },
/* harmony export */   "N5": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_TRENDING; },
/* harmony export */   "Nd": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_POLLING_COMPANY; },
/* harmony export */   "OR": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_FOLLOWED; },
/* harmony export */   "Ox": function() { return /* binding */ DATA_CY_SEARCH_STREAM_FILTER_FROM; },
/* harmony export */   "Ps": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_ALL_COMPANY; },
/* harmony export */   "SP": function() { return /* binding */ DATA_CY_USER_CATEGORY_NOTES; },
/* harmony export */   "Tb": function() { return /* binding */ DATA_CY_NAME_NOTES_MENU_COMPANY; },
/* harmony export */   "UL": function() { return /* binding */ DATA_CY_SEARCH_STREAM_MENU_SEARCH; },
/* harmony export */   "Ys": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION; },
/* harmony export */   "Zl": function() { return /* binding */ DATA_CY_NAME_STREAM_HEADER_MENU; },
/* harmony export */   "_t": function() { return /* binding */ DATA_CY_NAME_RESEARCH_HEADER_MENU; },
/* harmony export */   "b7": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER_COMPANY; },
/* harmony export */   "bJ": function() { return /* binding */ DATA_CY_SEARCH_STREAM_FILTER_TO; },
/* harmony export */   "c6": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_CHART_COMPANY; },
/* harmony export */   "dV": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER; },
/* harmony export */   "ed": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_POLLING; },
/* harmony export */   "gJ": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_WATCHLIST; },
/* harmony export */   "gz": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_REPORT_COMPANY; },
/* harmony export */   "h$": function() { return /* binding */ DATA_CY_SEARCH_STREAM_SUBMIT; },
/* harmony export */   "hL": function() { return /* binding */ DATA_CY_SEARCH_STREAM_MENU; },
/* harmony export */   "je": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_IDEA; },
/* harmony export */   "kk": function() { return /* binding */ DATA_CY_NAME_NEWS_HEADER_MENU_COMPANY; },
/* harmony export */   "lJ": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_PEOPLE; },
/* harmony export */   "p2": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_IDEA_COMPANY; },
/* harmony export */   "sQ": function() { return /* binding */ DATA_CY_NAME_RESEARCH_HEADER_MENU_COMPANY; },
/* harmony export */   "tG": function() { return /* binding */ DATA_CY_USER_CATEGORY_REPLIES; },
/* harmony export */   "tx": function() { return /* binding */ DATA_CY_SEARCH_STREAM_MENU_FILTER; },
/* harmony export */   "v6": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_CHART; },
/* harmony export */   "wv": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION_COMPANY; },
/* harmony export */   "xB": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_REPORT_ACTIVE; },
/* harmony export */   "zc": function() { return /* binding */ DATA_CY_USER_CATEGORY_PREDICTIONS; }
/* harmony export */ });
/* unused harmony exports DATA_CY_NAME_STREAM_HEADER_MENU_COMPANY, DATA_CY_SEARCH_STREAM_MENU_FILTER_COMPANY, DATA_CY_SEARCH_STREAM_MENU_SEARCH_COMPANY, DATA_CY_SEARCH_STREAM_FILTER_FROM_COMPANY, DATA_CY_SEARCH_STREAM_FILTER_TO_COMPANY, DATA_CY_SEARCH_STREAM_SUBMIT_COMPANY, DATA_CY_DROPDOWN_STREAM_TYPE_TRENDING_COMPANY, DATA_CY_DROPDOWN_STREAM_TYPE_FOLLOWED_COMPANY, DATA_CY_DROPDOWN_STREAM_TYPE_PEOPLE_COMPANY, DATA_CY_DROPDOWN_STREAM_TYPE_WATCHLIST_COMPANY */
var DATA_CY_NAME_STREAM_HEADER_MENU = "stream-header-menu";
var DATA_CY_NAME_STREAM_SUB_HEADER_IDEA = "stream-sub-header-idea";
var DATA_CY_NAME_STREAM_SUB_HEADER_REPORT = "stream-sub-header-reports";
var DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION = "stream-sub-header-predictions";
var DATA_CY_NAME_STREAM_SUB_HEADER_POLLING = "stream-sub-header-polling";
var DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER = "stream-sub-header-insiders";
var DATA_CY_NAME_STREAM_SUB_HEADER_CHART = "stream-sub-header-charts";
var DATA_CY_NAME_NEWS_HEADER_MENU = "news-header-menu";
var DATA_CY_NAME_RESEARCH_HEADER_MENU = "research-header-menu";
var DATA_CY_SEARCH_STREAM_MENU_FILTER = "search-stream-menu-filter";
var DATA_CY_SEARCH_STREAM_MENU = "search-stream-menu";
var DATA_CY_SEARCH_STREAM_MENU_SEARCH = "search-stream-menu-search";
var DATA_CY_SEARCH_STREAM_FILTER_FROM = "search-stream-filter-from";
var DATA_CY_SEARCH_STREAM_FILTER_TO = "search-stream-filter-to";
var DATA_CY_SEARCH_STREAM_SUBMIT = "search-stream-submit";
var DATA_CY_DROPDOWN_STREAM_ACTIVE = "dropdown-stream-active";
var DATA_CY_DROPDOWN_STREAM_TYPE_ALL = "dropdown-stream-type-all";
var DATA_CY_DROPDOWN_STREAM_TYPE_TRENDING = "dropdown-stream-type-trending";
var DATA_CY_DROPDOWN_STREAM_TYPE_FOLLOWED = "dropdown-stream-type-followed";
var DATA_CY_DROPDOWN_STREAM_TYPE_PEOPLE = "dropdown-stream-type-people";
var DATA_CY_DROPDOWN_STREAM_TYPE_WATCHLIST = "dropdown-stream-type-watchlist";
var DATA_CY_NAME_STREAM_HEADER_MENU_COMPANY = "stream-header-menu-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_IDEA_COMPANY = "stream-sub-header-idea-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_REPORT_COMPANY = "stream-sub-header-reports-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION_COMPANY = "stream-sub-header-predictions-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_POLLING_COMPANY = "stream-sub-header-polling-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER_COMPANY = "stream-sub-header-insiders-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_CHART_COMPANY = "stream-sub-header-charts-company";
var DATA_CY_NAME_NEWS_HEADER_MENU_COMPANY = "news-header-menu-company";
var DATA_CY_NAME_NOTES_MENU_COMPANY = "stream-notes-compose-company";
var DATA_CY_NAME_RESEARCH_HEADER_MENU_COMPANY = "research-header-menu-company";
var DATA_CY_SEARCH_STREAM_MENU_FILTER_COMPANY = "search-stream-menu-filter-company";
var DATA_CY_SEARCH_STREAM_MENU_SEARCH_COMPANY = "search-stream-menu-search-company";
var DATA_CY_SEARCH_STREAM_FILTER_FROM_COMPANY = "search-stream-filter-from-company";
var DATA_CY_SEARCH_STREAM_FILTER_TO_COMPANY = "search-stream-filter-to-company";
var DATA_CY_SEARCH_STREAM_SUBMIT_COMPANY = "search-stream-submit-company";
var DATA_CY_DROPDOWN_STREAM_TYPE_ALL_COMPANY = "dropdown-stream-type-all-company";
var DATA_CY_DROPDOWN_STREAM_TYPE_TRENDING_COMPANY = "dropdown-stream-type-trending-company";
var DATA_CY_DROPDOWN_STREAM_TYPE_FOLLOWED_COMPANY = "dropdown-stream-type-followed-company";
var DATA_CY_DROPDOWN_STREAM_TYPE_PEOPLE_COMPANY = "dropdown-stream-type-people-company";
var DATA_CY_DROPDOWN_STREAM_TYPE_WATCHLIST_COMPANY = "dropdown-stream-type-watchlist-company";
var DATA_CY_DROPDOWN_STREAM_REPORT_ACTIVE = "dropdown-stream-report-active";
var DATA_CY_USER_CATEGORY_IDEAS = "user-category-ideas";
var DATA_CY_USER_CATEGORY_REPLIES = "user-category-replies";
var DATA_CY_USER_CATEGORY_CHARTS = "user-category-charts";
var DATA_CY_USER_CATEGORY_LIKED = "user-category-liked";
var DATA_CY_USER_CATEGORY_SAVED = "user-category-saved";
var DATA_CY_USER_CATEGORY_PREDICTIONS = "user-category-predictions";
var DATA_CY_USER_CATEGORY_NOTES = "user-category-notes";


/***/ }),

/***/ 21390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DY": function() { return /* binding */ TAB_USER_CATEGORIES; },
/* harmony export */   "Hw": function() { return /* binding */ nonSourceNews; },
/* harmony export */   "J1": function() { return /* binding */ streamTypes; },
/* harmony export */   "Lv": function() { return /* binding */ warningContent; },
/* harmony export */   "OW": function() { return /* binding */ STREAM_REPORT; },
/* harmony export */   "PA": function() { return /* binding */ STREAM_TABS_MY; },
/* harmony export */   "R5": function() { return /* binding */ STREAM_TYPE; },
/* harmony export */   "Sb": function() { return /* binding */ DEFAULT_TYPE; },
/* harmony export */   "U1": function() { return /* binding */ reportCategories; },
/* harmony export */   "Z9": function() { return /* binding */ DEFAULT_HEADER; },
/* harmony export */   "bd": function() { return /* binding */ categories; },
/* harmony export */   "c$": function() { return /* binding */ reportOptions; },
/* harmony export */   "cT": function() { return /* binding */ stockChange; },
/* harmony export */   "eB": function() { return /* binding */ STREAM_STATE; },
/* harmony export */   "gd": function() { return /* binding */ MAX_TIPPING_AMOUNT; },
/* harmony export */   "hD": function() { return /* binding */ STREAM_VERSION; },
/* harmony export */   "oE": function() { return /* binding */ LS_STREAM_TRENDING_TAB_DATE; },
/* harmony export */   "oK": function() { return /* binding */ TAB_CATEGORIES; },
/* harmony export */   "q1": function() { return /* binding */ STREAM_TABS; },
/* harmony export */   "u3": function() { return /* binding */ defaultReportLabel; }
/* harmony export */ });
/* unused harmony exports STREAM_CATEGORY_ENUM, STREAM_REPORT_TYPE_ENUM */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22147);
/* harmony import */ var _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41351);

var ref;


var STREAM_TYPE = {
    GENERIC: "generic",
    USER: "user",
    SYMBOL: "symbol"
};
var genericCategories = [
    {
        label: "Ideas",
        key: "ideas",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_IDEA */ .je
    },
    {
        label: "Reports",
        key: "reports",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_REPORT */ .BT
    },
    {
        label: "Predictions",
        key: "predictions",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION */ .Ys
    },
    {
        label: "Polling",
        key: "pollings",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_POLLING */ .ed
    },
    {
        label: "Insiders",
        key: "insider",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER */ .dV
    },
    {
        label: "Charts",
        key: "charts",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_CHART */ .v6
    }, 
];
var symbolCategories = [
    {
        label: "All",
        key: "all",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_ALL_COMPANY */ .Ps
    },
    {
        label: "Notes",
        key: "notes",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_NOTES_MENU_COMPANY */ .Tb
    },
    {
        label: "News",
        key: "news",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_NEWS_HEADER_MENU_COMPANY */ .kk
    },
    {
        label: "Reports",
        key: "reports",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_REPORT_COMPANY */ .gz
    },
    {
        label: "Research",
        key: "research",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_RESEARCH_HEADER_MENU_COMPANY */ .sQ
    },
    {
        label: "Ideas",
        key: "ideas",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_IDEA_COMPANY */ .p2
    },
    {
        label: "Predictions",
        key: "predictions",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION_COMPANY */ .wv
    },
    {
        label: "Polling",
        key: "pollings",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_POLLING_COMPANY */ .Nd
    },
    {
        label: "Insiders",
        key: "insider",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER_COMPANY */ .b7
    },
    {
        label: "Charts",
        key: "charts",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_CHART_COMPANY */ .c6
    }, 
];
var userCategories = [
    {
        label: "Ideas",
        key: "main ideas",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_IDEAS */ .D6
    },
    {
        label: "Notes",
        key: "notes",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_NOTES */ .SP
    },
    {
        label: "Replies",
        key: "reply",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_REPLIES */ .tG
    },
    {
        label: "Charts",
        key: "charts",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_CHARTS */ .En
    },
    {
        label: "Liked",
        key: "liked",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_LIKED */ .Me
    },
    {
        label: "Saved",
        key: "saved",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_SAVED */ .LO
    },
    {
        label: "Predictions",
        key: "predictions",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_PREDICTIONS */ .zc
    }, 
];
var _obj;
var categories = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, STREAM_TYPE.GENERIC, genericCategories), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, STREAM_TYPE.SYMBOL, symbolCategories), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, STREAM_TYPE.USER, userCategories), _obj);
var streamTypes = [
    {
        label: "Trending",
        key: "trending",
        lsKey: "trending",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_TRENDING */ .N5
    },
    {
        label: "Followed",
        key: "all watchlist",
        lsKey: "following",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_FOLLOWED */ .OR
    },
    {
        label: "All",
        key: "latest",
        lsKey: "latest",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_ALL */ .Js
    },
    {
        label: "People",
        key: "people watchlist",
        lsKey: "following_people",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_PEOPLE */ .lJ
    },
    {
        label: "Watchlist",
        key: "company watchlist",
        lsKey: "following_company",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_WATCHLIST */ .gJ
    }, 
];
var reportCategories = [
    {
        label: "All",
        key: "all"
    },
    {
        label: "Laporan Keuangan",
        key: "laporan_keuangan"
    },
    {
        label: "RUPS/Public Expose",
        key: "rups"
    },
    {
        label: "Kepemilikan Saham",
        key: "kepemilikan_saham"
    },
    {
        label: "Dividend",
        key: "dividend"
    },
    {
        label: "Corporate Action",
        key: "corporate_action"
    },
    {
        label: "Others",
        key: "others"
    }, 
];
var reportOptions = [
    {
        key: "1",
        label: "Improper Use of $ Tag"
    },
    {
        key: "2",
        label: "Incorrect Writing Standard"
    },
    {
        key: "3",
        label: "Advertising"
    },
    {
        key: "4",
        label: "Junk Post"
    },
    {
        key: "5",
        label: "Spam",
        default: true
    },
    {
        key: "6",
        label: "Out of Topic"
    },
    {
        key: "7",
        label: "Vulgarity"
    },
    {
        key: "8",
        label: "Abusive Behaviour"
    },
    {
        key: "9",
        label: "Provoking Other Users"
    },
    {
        key: "10",
        label: "Inapropriate Username & Photo"
    },
    {
        key: "11",
        label: "Stocks Cheering"
    }, 
];
var defaultReportLabel = ((ref = reportOptions.find(function(report) {
    return report.default;
})) === null || ref === void 0 ? void 0 : ref.label) || "Spam";
var stockChange = {
    netral: {
        icon: "",
        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"].nobel */ .Z.nobel
    },
    up: {
        icon: "icon-symbol_up",
        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"].primary */ .Z.primary
    },
    down: {
        icon: "icon-symbol_down",
        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"].sunsetOrange */ .Z.sunsetOrange
    }
};
var STREAM_STATE = {
    CATEGORY: "stbx-active-stream-filter",
    TYPE: "stbx-active-stream",
    TAB: "stbx-active-stream-header"
};
var nonSourceNews = {
    stockbitnews: {
        username: "StockbitNews",
        label: "Stockbit News",
        extend: true,
        image: "/img/sbnewsicon.png"
    },
    klsenews: {
        username: "KLSEnews",
        label: "KLSENews",
        extend: false,
        image: "/img/sbnewsicon.png"
    }
};
var STREAM_TABS = [
    {
        label: "Stream",
        value: "stream",
        icon: "/icon/stream-filter/header-stream",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_HEADER_MENU */ .Zl
    },
    {
        label: "News",
        value: "news",
        icon: "/icon/stream-filter/header-news",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_NEWS_HEADER_MENU */ .EJ
    },
    {
        label: "Research",
        value: "research",
        icon: "/icon/stream-filter/header-research",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_RESEARCH_HEADER_MENU */ ._t
    }, 
];
var STREAM_TABS_MY = [
    {
        label: "Stream",
        value: "stream",
        icon: "/icon/stream-filter/header-stream",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_HEADER_MENU */ .Zl
    }, 
];
var DEFAULT_TYPE = "ideas";
var DEFAULT_HEADER = "stream";
var MAX_TIPPING_AMOUNT = 10000000;
var LS_STREAM_TRENDING_TAB_DATE = "stbx-active-trending-date";
// Constants for stream v3 (general, company, user)
var STREAM_VERSION = {
    DEFAULT: "exodus",
    V3: "exodus_v3"
};
var STREAM_CATEGORY_ENUM = {
    ALL: "STREAM_CATEGORY_ALL",
    ALL_WATCHLIST: "STREAM_CATEGORY_ALL_WATCHLIST",
    PEOPLE_WATCHLIST: "STREAM_CATEGORY_PEOPLE_WATCHLIST",
    COMPANY_WATCHLIST: "STREAM_CATEGORY_COMPANY_WATCHLIST",
    NEWS: "STREAM_CATEGORY_NEWS",
    CHART: "STREAM_CATEGORY_CHART",
    CHARTS: "STREAM_CATEGORY_CHART",
    REPORTS: "STREAM_CATEGORY_REPORTS",
    IDEAS: "STREAM_CATEGORY_IDEAS",
    INSIDER: "STREAM_CATEGORY_INSIDER",
    PREDICTION: "STREAM_CATEGORY_PREDICTION",
    PREDICTIONS: "STREAM_CATEGORY_PREDICTION",
    POLLING: "STREAM_CATEGORY_POLLING",
    POLLINGS: "STREAM_CATEGORY_POLLING",
    REPLY: "STREAM_CATEGORY_REPLY",
    MAIN_IDEAS: "STREAM_CATEGORY_MAIN_IDEAS",
    LIKED: "STREAM_CATEGORY_LIKED",
    SAVED: "STREAM_CATEGORY_SAVED",
    RESEARCH: "research"
};
var TAB_CATEGORIES = {
    all: STREAM_CATEGORY_ENUM.ALL,
    ideas: STREAM_CATEGORY_ENUM.IDEAS,
    news: STREAM_CATEGORY_ENUM.NEWS,
    reports: STREAM_CATEGORY_ENUM.REPORTS,
    charts: STREAM_CATEGORY_ENUM.CHART,
    insider: STREAM_CATEGORY_ENUM.INSIDER,
    predictions: STREAM_CATEGORY_ENUM.PREDICTION,
    pollings: STREAM_CATEGORY_ENUM.POLLING,
    latest: STREAM_CATEGORY_ENUM.IDEAS,
    "all watchlist": STREAM_CATEGORY_ENUM.ALL_WATCHLIST,
    "people watchlist": STREAM_CATEGORY_ENUM.PEOPLE_WATCHLIST,
    "company watchlist": STREAM_CATEGORY_ENUM.COMPANY_WATCHLIST
};
var TAB_USER_CATEGORIES = {
    "main ideas": STREAM_CATEGORY_ENUM.MAIN_IDEAS,
    reply: STREAM_CATEGORY_ENUM.REPLY,
    charts: STREAM_CATEGORY_ENUM.CHART,
    liked: STREAM_CATEGORY_ENUM.LIKED,
    saved: STREAM_CATEGORY_ENUM.SAVED,
    predictions: STREAM_CATEGORY_ENUM.PREDICTIONS
};
var STREAM_REPORT_TYPE_ENUM = {
    OTHER: "REPORT_TYPE_OTHER",
    LAPORAN_KEUANGAN: "REPORT_TYPE_LAPORAN_KEUANGAN",
    RUPS: "REPORT_TYPE_RUPS",
    KEPIMILIKAN_SAHAM: "REPORT_TYPE_KEPIMILIKAN_SAHAM",
    DIVIDEN: "REPORT_TYPE_DIVIDEN",
    CORPORATE_ACTION: "REPORT_TYPE_CORPORATE_ACTION",
    ALL: "REPORT_TYPE_ALL"
};
var STREAM_REPORT = {
    all: STREAM_REPORT_TYPE_ENUM.ALL,
    laporan_keuangan: STREAM_REPORT_TYPE_ENUM.LAPORAN_KEUANGAN,
    rups: STREAM_REPORT_TYPE_ENUM.RUPS,
    kepemilikan_saham: STREAM_REPORT_TYPE_ENUM.KEPIMILIKAN_SAHAM,
    dividend: STREAM_REPORT_TYPE_ENUM.DIVIDEN,
    corporate_action: STREAM_REPORT_TYPE_ENUM.CORPORATE_ACTION,
    others: STREAM_REPORT_TYPE_ENUM.OTHER
};
var warningContent = "Post ini mungkin mengandung konten scam atau iklan yang melanggar peraturan komunitas Stockbit. Mohon berhati-hati dengan adanya potensi penipuan berujung investasi bodong. Jangan memberikan informasi sensitif, transfer uang atau tergiur dengan ajakan investasi yang diberikan oleh penulis.";



/***/ }),

/***/ 63699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37213);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68425);
/* harmony import */ var features_discover_people_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28635);
/* eslint-disable import/named */ 


var requestExodus = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
var suggestionURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/friend-discovery/suggestions");
var FRIEND_DISCOVERY = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/friend-discovery");
var getSuggestFriends = function(config) {
    var limit = config.limit, page = config.page, _filter = config.filter, filter = _filter === void 0 ? 0 : _filter;
    return requestExodus.get("".concat(suggestionURL, "/query"), {
        params: {
            limit: limit,
            page: page,
            filter: filter
        }
    });
};
var getSuggestFriendsContacts = function(limit, page) {
    return requestExodus.get("".concat(suggestionURL, "/contacts"), {
        params: {
            limit: limit,
            page: page
        }
    });
};
var getBlacklistStatus = function() {
    return requestExodus.get("".concat(FRIEND_DISCOVERY, "/contacts/discoverable"));
};
var updateBlacklistStatus = function() {
    return requestExodus.post("".concat(FRIEND_DISCOVERY, "/contacts/discoverable"));
};
var getContactSyncStatus = function() {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/friend-discovery/contacts/status"));
};
var getFollowedBy = function(params) {
    return requestExodus.get("".concat(FRIEND_DISCOVERY, "/followed-by"), {
        params: params
    });
};
var getTrending = function() {
    var timeframe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : features_discover_people_types__WEBPACK_IMPORTED_MODULE_2__/* .TrendingTimeFrame.ALL */ .b.ALL, limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, cursor = arguments.length > 2 ? arguments[2] : void 0;
    return requestExodus.get("user/v2/discovery/trending", {
        params: {
            time_frame: timeframe,
            limit: limit,
            cursor: cursor
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getSuggestFriends: getSuggestFriends,
    getSuggestFriendsContacts: getSuggestFriendsContacts,
    getBlacklistStatus: getBlacklistStatus,
    updateBlacklistStatus: updateBlacklistStatus,
    getContactSyncStatus: getContactSyncStatus,
    getFollowedBy: getFollowedBy,
    getTrending: getTrending
});


/***/ }),

/***/ 51679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);
/* harmony import */ var global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21390);
/* harmony import */ var utils_stream__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14601);
/** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */ /* eslint-disable camelcase */ 





var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestExodusNoAlert = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].noAlert */ .Z.noAlert;
// TODO: Change exodus url to stream url later on after every `/stream` path is migrated and tested
var STREAM_EXODUS_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/stream");
var STREAM_EXODUS_V3_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/stream/v3");
var STREAM_UPLOAD_TOKEN = "".concat(STREAM_EXODUS_URL, "/uploadtoken");
var STREAM_UPLOAD_TOKEN_V2 = "".concat(STREAM_EXODUS_URL, "/upload-tokens");
// Stockbit Stream -------------------------------------------------------------
/**
 * like stream post
 * @param {string} postid - post id
 * @returns {APIResponse}
 */ var likeStreamPost = function(postid) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/like/").concat(postid));
};
/**
 * unlike stream post
 * @param {string} postid - post id
 * @returns {APIResponse}
 */ var unlikeStreamPost = function(postid) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/unlike/").concat(postid));
};
/**
 *
 * @param {number=} version
 *
 * @param {Object} param
 * @param {number=} param.clean
 * @param {number=} param.beforelastpost
 * @param {string=} param.category
 * @param {number=} param.lastpost
 * @param {*=} param.keyword
 * @param {number=} param.limit
 * @param {string=} param.from
 * @param {string=} param.to
 * @param {string=} param.beforetimestamp
 * @returns {APIResponse}
 */ var getStream = function() {
    var version = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .STREAM_VERSION.V3 */ .hD.V3, ref = arguments.length > 1 ? arguments[1] : void 0, _clean = ref.clean, clean = _clean === void 0 ? 0 : _clean, _beforelastpost = ref.beforelastpost, beforelastpost = _beforelastpost === void 0 ? 0 : _beforelastpost, _category = ref.category, category = _category === void 0 ? "all" : _category, _lastpost = ref.lastpost, lastpost = _lastpost === void 0 ? 0 : _lastpost, keyword = ref.keyword, _limit = ref.limit, limit = _limit === void 0 ? 20 : _limit, _type = ref.type, type = _type === void 0 ? "latest" : _type, _from = ref.from, from = _from === void 0 ? "" : _from, _to = ref.to, to = _to === void 0 ? "" : _to, _beforetimestamp = ref.beforetimestamp, beforetimestamp = _beforetimestamp === void 0 ? null : _beforetimestamp, _date = ref.date, date = _date === void 0 ? moment__WEBPACK_IMPORTED_MODULE_0___default()(new Date()).format("YYYY-MM-DD") : _date, _page = ref.page, page = _page === void 0 ? 1 : _page, _reporttype = ref.reporttype, reporttype = _reporttype === void 0 ? "" : _reporttype;
    var params = {
        clean: clean,
        beforelastpost: beforelastpost,
        category: category,
        lastpost: lastpost,
        keyword: keyword,
        limit: limit,
        from: from,
        to: to,
        beforetimestamp: beforetimestamp
    };
    var streamURL = STREAM_EXODUS_V3_URL;
    if (type === "latest") {
        params.category = category;
        if (category === "reports") {
            params.reporttype = reporttype;
        }
    } else if (type === "trending" && !keyword) {
        streamURL = "".concat(streamURL, "/trending");
        params = {
            date: date,
            page: page,
            limit: limit
        };
    } else {
        // For non Ideas Filter will have type 'ideas', use category as category
        // For Ideas with non 'All' filter, use type as category
        if (type === "ideas") {
            params.category = category;
        } else if (type === "trending" && keyword) {
            params.category = category;
        } else {
            params.category = type;
        }
        // Only report category has reporttype
        if (category === "reports") {
            params.reporttype = reporttype;
        } else {
            params.filter = "all";
        }
    }
    // Cleanup params with empty value
    params = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(params);
    var body = {};
    if (type !== "trending" || keyword) {
        body = {
            category: global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .TAB_CATEGORIES */ .oK[params.category],
            last_stream_id: lastpost,
            last_reply: beforetimestamp,
            keyword: keyword,
            from_date: from,
            to_date: to,
            limit: limit
        };
        if (params.reporttype) {
            // eslint-disable-next-line dot-notation
            body["report_type"] = global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .STREAM_REPORT */ .OW[params.reporttype];
        }
    } else if (type === "trending" && !keyword) {
        body = {
            date: date,
            last_stream_id: lastpost,
            limit: limit
        };
    }
    body = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(body);
    var queries = new URLSearchParams(body).toString();
    if (type === "trending" && !keyword) {
        return requestExodus.post(streamURL, body);
    }
    return requestExodus.get("".concat(streamURL, "?").concat(queries));
};
/**
 * Get user stream data
 * @param {string} username
 *
 * @param {Object} param
 * @param {number} param.beforelastpost
 * @param {string} param.category
 * @param {number} param.lastpost
 * @param {*} param.keyword
 * @param {number} param.limit
 * @param {string} param.from
 * @param {string} param.to
 * @returns {APIResponse}
 */ var getUserStream = function(username, param) {
    var _category = param.category, category = _category === void 0 ? "all" : _category, _lastpost = param.lastpost, lastpost = _lastpost === void 0 ? 0 : _lastpost, keyword = param.keyword, _limit = param.limit, limit = _limit === void 0 ? 20 : _limit, _from = param.from, from = _from === void 0 ? "" : _from, _to = param.to, to = _to === void 0 ? "" : _to;
    var streamURL = "".concat(STREAM_EXODUS_V3_URL, "/user");
    var body = {
        category: global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .TAB_USER_CATEGORIES */ .DY[category],
        last_stream_id: lastpost,
        keyword: keyword,
        from_date: from,
        to_date: to,
        limit: limit
    };
    body = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(body);
    return requestExodus.post("".concat(streamURL, "/").concat(username), body);
};
/**
 * Get company stream data
 * @param {string} symbol
 *
 * @param {Object} param
 * @param {number} param.beforelastpost
 * @param {string} param.category
 * @param {number} param.lastpost
 * @param {*} param.keyword
 * @param {number} param.limit
 * @param {string} param.from
 * @param {string} param.to
 * @returns {APIResponse}
 */ var getSymbolStream = function(symbol, param) {
    var _category = param.category, category = _category === void 0 ? "all" : _category, _lastpost = param.lastpost, lastpost = _lastpost === void 0 ? 0 : _lastpost, keyword = param.keyword, _limit = param.limit, limit = _limit === void 0 ? 20 : _limit, _from = param.from, from = _from === void 0 ? "" : _from, _to = param.to, to = _to === void 0 ? "" : _to, _reporttype = param.reporttype, reporttype = _reporttype === void 0 ? "" : _reporttype;
    var streamURL = "".concat(STREAM_EXODUS_V3_URL, "/symbol");
    var body = {};
    body = {
        category: global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .TAB_CATEGORIES */ .oK[category],
        last_stream_id: lastpost,
        keyword: keyword,
        from_date: from,
        to_date: to,
        limit: limit
    };
    if (reporttype) {
        // eslint-disable-next-line dot-notation
        body["report_type"] = global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .STREAM_REPORT */ .OW[reporttype];
    }
    body = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(body);
    var queries = new URLSearchParams(body).toString();
    // return requestExodusNoAlert.post(`${streamURL}/${symbol}`, body);
    return requestExodus.get("".concat(streamURL, "/").concat(symbol, "?").concat(queries));
};
/**
 * Get stream post detail by post id
 * @param {string} symbol
 * @returns {APIResponse}
 */ var getGuestStream = function(symbol) {
    return requestExodusNoAlert.get("".concat(STREAM_EXODUS_URL, "/non-login/symbol/").concat(symbol));
};
/**
 * Get company data for guest
 * @param {string} symbol
 * @returns {APIResponse}
 */ var getGuestCompany = function(symbol) {
    return requestExodusNoAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/emitten/non-login/").concat(symbol, "/info"));
};
/**
 * Get company profile info
 * @param {string} symbol
 * @returns {APIResponse}
 */ var getGuestCompanyProfile = function(symbol) {
    return requestExodusNoAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/partnership/emitten/").concat(symbol, "/profile"));
};
/**
 * Get chart data for guest
 * @param {string} symbol
 * @returns {APIResponse}
 */ var getGuestChart = function(symbol) {
    var timeframe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "today";
    return requestExodusNoAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/partnership/charts/").concat(symbol, "/daily?timeframe=").concat(timeframe));
};
/**
 * Get stream post detail by post id
 * @param {string|number} postId
 * @returns {APIResponse}
 */ var getStreamDetail = function(postId) {
    var streamURL = "".concat(STREAM_EXODUS_V3_URL, "/post/").concat(postId);
    return requestExodusNoAlert.post(streamURL);
};
/**
 * Get stream post detail by post id
 * @param {string|number} postId
 * @returns {APIResponse}
 */ var getGuestStreamDetail = function(postId) {
    return requestExodusNoAlert.get("".concat(STREAM_EXODUS_URL, "/non-login/post/").concat(postId));
};
/**
 * getUploadToken
 * @param {string} bucket - bucket'sname
 * @returns {APIResponse}
 */ var getUploadToken = function() {
    var bucket = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "avatar";
    return requestExodusNoAlert.get("".concat(STREAM_UPLOAD_TOKEN), {
        params: {
            bucket: bucket
        }
    });
};
/**
 * postUploadAWS
 * @param {object} formData - file formdata
 * @returns {APIResponse}
 */ var postUploadAWS = function(formData) {
    return fetch(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .AWS_AVATAR_BUCKET */ .cU, {
        method: "POST",
        cache: "default",
        body: formData,
        mode: "cors"
    }).then(function(response) {
        if (response.status === 200) {
            return response.json();
        }
        // TODO: alert error message
        return false;
    });
};
/**
 * API Compose new Stream
 * @param {Object} param
 * @param {string} param.content
 * @param {string} param.image
 * @param {Array} param.images
 * @param {Object} param.file
 * @param {number} param.target_price
 * @param {string} param.target_symbol
 * @param {number} param.target_duration
 * @param {Object=} param.polling
 * @param {string} param.commenter_type
 * @returns {APIResponse}
 */ var postStream = function(param) {
    var content = param.content, image = param.image, _images = param.images, images = _images === void 0 ? [] : _images, _file = param.file, file = _file === void 0 ? "" : _file, target_price = param.target_price, target_symbol = param.target_symbol, target_duration = param.target_duration, polling = param.polling, commenter_type = param.commenter_type;
    var data = {
        content: content,
        image: image,
        images: images,
        file: file,
        target_price: target_price,
        target_symbol: target_symbol,
        target_duration: target_duration,
        sharefacebook: 0,
        sharetwitter: 0,
        commenter_type: commenter_type
    };
    if (polling) {
        data.polling_end = polling.polling_end;
        data.polling_options = polling.polling_options;
        data.polling_pin = polling.polling_pin;
    }
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/write"), data);
};
/**
 * API Update Post Stream
 * @param {Object} param
 * @param {string} param.content
 * @param {string} param.image
 * @param {Array} param.images
 * @param {Object} param.file
 * @param {number} param.target_price
 * @param {string} param.target_symbol
 * @param {number} param.target_duration
 * @param {Object=} param.polling
 * @param {number} param.postid
 * @param {string} param.commenter_type
 * @returns {APIResponse}
 */ var updatePostStream = function(param) {
    var content = param.content, image = param.image, _images = param.images, images = _images === void 0 ? [] : _images, _file = param.file, file = _file === void 0 ? "" : _file, target_price = param.target_price, target_symbol = param.target_symbol, target_duration = param.target_duration, polling = param.polling, postid = param.postid, commenter_type = param.commenter_type;
    var data = {
        content: content,
        image: image,
        images: images,
        file: file,
        target_price: target_price,
        target_symbol: target_symbol,
        target_duration: target_duration,
        sharefacebook: 0,
        sharetwitter: 0,
        commenter_type: commenter_type
    };
    if (polling) {
        data.polling_end = polling.polling_end;
        data.polling_options = polling.polling_options;
        data.polling_pin = polling.polling_pin;
    }
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/update/").concat(postid), data);
};
/**
 * API Share Post Stream
 * @param {Object} param
 * @param {string} param.content
 * @param {string} param.images
 * @param {Object} param.file
 * @param {number} param.postid
 * @param {number=} param.facebook
 * @param {number=} param.twitter
 * @param {number=} param.stockbit
 * @param {number=} param.commenter_type
 * @returns {APIResponse}
 */ var sharePostStream = function(param) {
    var content = param.content, images = param.images, file = param.file, postid = param.postid, _facebook = param.facebook, facebook = _facebook === void 0 ? 0 : _facebook, _twitter = param.twitter, twitter = _twitter === void 0 ? 0 : _twitter, _stockbit = param.stockbit, stockbit = _stockbit === void 0 ? 0 : _stockbit, commenter_type = param.commenter_type;
    var data = {
        postid: postid,
        content: content,
        images: images,
        file: file,
        facebook: facebook,
        twitter: twitter,
        stockbit: stockbit,
        commenter_type: commenter_type
    };
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/share/").concat(postid), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data));
};
/**
 * Function to post vote to target price post
 * @param {number} targetPriceId - target price id
 * @param {0 | 1} agree - agree status 1: agree, 0: disagree
 * @returns {APIResponse}
 */ var postVoteTargetPrice = function(targetPriceId, agree) {
    var bodyFormData = new URLSearchParams();
    bodyFormData.append("tp_id", targetPriceId);
    bodyFormData.append("agree", agree);
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/addvote/").concat(targetPriceId), bodyFormData);
};
/**
 * Follow Post
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var followPost = function(postid) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/follow/").concat(postid));
};
/**
 * UnFollow Post
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var unfollowPost = function(postid) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/unfollow/").concat(postid));
};
/**
 * Save Post
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var savePost = function(postid) {
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/save/").concat(postid));
};
/**
 * UnSave Post
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var unsavePost = function(postid) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/unsave/").concat(postid));
};
/**
 *  Get Announcement Report
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var getAnnouncementReports = function(postid) {
    return requestExodusNoAlert.get("".concat(STREAM_EXODUS_URL, "/announcement/").concat(postid));
};
/**
 * Post Report Stream
 * @param {number|string} postid
 * @param {string} type
 * @param {string} message
 * @returns {APIResponse}
 */ var postReportStream = function(postid, type, message) {
    var form = new URLSearchParams();
    form.append("type", type);
    form.append("message", message);
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/report/").concat(postid), form);
};
/**
 * Delete Post Stream
 * @param {number|string} postid
 * @param {string} reason
 * @param {boolean} sendEmail
 * @returns {APIResponse}
 */ var deletePostStream = function(postid, reason) {
    var sendEmail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var data = {
        reason: reason,
        send_email: sendEmail
    };
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/v2/delete/").concat(postid), data);
};
/**
 * Delete Own Post Stream
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var deleteOwnPostStream = function(postid) {
    return requestExodus.delete("".concat(STREAM_EXODUS_URL, "/own/").concat(postid));
};
/**
 * Delete Own Post Stream
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var deleteOwnPostComment = function(postid) {
    return requestExodus.delete("".concat(STREAM_EXODUS_URL, "/own/comment/").concat(postid));
};
/**
 * Delete Multiple Post Stream
 * @param {number|string} userid
 * @param {string} time
 * @param {string} reason
 * @param {bool} sendEmail
 * @returns {APIResponse}
 */ var deleteMultiplePostStream = function(userid, time, reason) {
    var sendEmail = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var data = {
        user_id: userid,
        period: time,
        send_email: sendEmail,
        reason: reason
    };
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/delete/multiple"), data);
};
/**
 * Pin Post
 * @param {number|string} postid
 * @param {string} symbol
 * @returns {APIResponse}
 */ var pinPost = function(postid, symbol) {
    var data = new URLSearchParams();
    data.append("postid", postid);
    if (symbol) data.append("symbol", symbol);
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/pin?").concat(data.toString()));
};
/**
 * UnPin Post
 * @param {number|string} postid
 * @param {string} symbol
 * @returns {APIResponse}
 */ var unpinPost = function(postid, symbol) {
    var data = new URLSearchParams();
    data.append("postid", postid);
    if (symbol) data.append("symbol", symbol);
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/unpin?").concat(data.toString()));
};
/**
 * Get user pinned post
 * @param {string} username
 * @returns {APIResponse}
 */ var getPinnedPost = function(username) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_V3_URL, "/user/").concat(username, "/pinned"));
};
/**
 * Get company pinned post
 * @param {string} symbol
 * @returns {APIResponse}
 */ var getCompanyPinnedPost = function(symbol) {
    return requestExodusNoAlert.get("/stream/v3/symbol/".concat(symbol, "/pinned"));
};
/**
 * Get Stream Conversation
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var getStreamConversation = function(param) {
    var postId = param.postId, parentId = param.parentId;
    var streamURL = "".concat(STREAM_EXODUS_V3_URL, "/conversation");
    var body = {
        stream_id: postId,
        limit: 20
    };
    var parentID = parentId > 0 ? parentId : postId;
    body = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(body);
    return requestExodusNoAlert.post("".concat(streamURL, "/").concat(parentID), body);
};
/**
 * Get Prev Stream Conversation
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var getPrevStreamConversation = function(postid) {
    var streamURL = "".concat(STREAM_EXODUS_V3_URL, "/conversation");
    var body = {
        stream_id: postid,
        is_previous: true,
        limit: 20
    };
    body = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(body);
    return requestExodusNoAlert.post("".concat(streamURL, "/comments"), body);
};
/**
 * Post Reply Stream
 * @param {Object} param
 * @param {string=} param.content
 * @param {string=} param.image
 * @param {string=} param.images
 * @param {Object=} param.file
 * @param {number=} param.postid
 * @param {number} param.replyto
 * @param {number|string} param.parent
 * @returns {APIResponse}
 */ var postReplyStream = function(param) {
    var _content = param.content, content = _content === void 0 ? "" : _content, _image = param.image, image = _image === void 0 ? null : _image, _images = param.images, images = _images === void 0 ? [] : _images, _file = param.file, file = _file === void 0 ? null : _file, replyto = param.replyto, parent = param.parent;
    var data = {
        content: content,
        image: image,
        images: images,
        file: file,
        sharefacebook: 0,
        sharetwitter: 0
    };
    if (replyto) {
        data.replyto = replyto;
    }
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/reply/").concat(parent), data);
};
/**
 * Untag all post topics inside stream post
 * @param {number} postId - Stream post ID
 * @returns {APIResponse}
 */ var untagPostTopic = function(postId) {
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/topic/untag/").concat(postId));
};
/**
 * Get stream likers
 * @param {string} username
 * @param {string | number} postid
 * @param {number} page
 * @return {APIResponse}
 */ var getStreamLikers = function(username, postid) {
    var page = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    return requestExodusNoAlert.get("".concat(STREAM_EXODUS_URL, "/likers/").concat(postid), {
        params: {
            username: username,
            page: page
        }
    });
};
/**
 * getUploadToken version 2
 * @param {string} filename
 * @returns {APIResponse}
 */ var getUploadTokenV2 = function(params) {
    return requestExodusNoAlert.get("".concat(STREAM_UPLOAD_TOKEN_V2), {
        params: params
    });
};
/**
 * Change Commenter Type of Post
 * @param {number} type - Stream post Commenter Type
 * @param {string | number} postid
 * @returns {APIResponse}
 */ var changeCommenterType = function(type, postid) {
    return requestExodus.put("".concat(STREAM_EXODUS_URL, "/commenter-type/").concat(postid), {
        commenter_type: type
    });
};
/**
 * Post Polling Vote
 * @param {number} pollingId - Stream post ID
 * @param {number} option - selected option
 * @returns {APIResponse}
 */ var postPollingVote = function(pollingId, option) {
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/polling/vote/").concat(pollingId), {
        option: option
    });
};
var getGuestUserStream = function(username) {
    return requestExodusNoAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/stream/non-login/user/").concat(username));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    likeStreamPost: likeStreamPost,
    unlikeStreamPost: unlikeStreamPost,
    getStream: getStream,
    getUserStream: getUserStream,
    getSymbolStream: getSymbolStream,
    getStreamDetail: getStreamDetail,
    getUploadToken: getUploadToken,
    postUploadAWS: postUploadAWS,
    postStream: postStream,
    updatePostStream: updatePostStream,
    sharePostStream: sharePostStream,
    postVoteTargetPrice: postVoteTargetPrice,
    followPost: followPost,
    unfollowPost: unfollowPost,
    savePost: savePost,
    unsavePost: unsavePost,
    getAnnouncementReports: getAnnouncementReports,
    postReportStream: postReportStream,
    deletePostStream: deletePostStream,
    deleteOwnPostStream: deleteOwnPostStream,
    deleteOwnPostComment: deleteOwnPostComment,
    deleteMultiplePostStream: deleteMultiplePostStream,
    pinPost: pinPost,
    unpinPost: unpinPost,
    getPinnedPost: getPinnedPost,
    getCompanyPinnedPost: getCompanyPinnedPost,
    getStreamLikers: getStreamLikers,
    getStreamConversation: getStreamConversation,
    getPrevStreamConversation: getPrevStreamConversation,
    postReplyStream: postReplyStream,
    untagPostTopic: untagPostTopic,
    getUploadTokenV2: getUploadTokenV2,
    getGuestStreamDetail: getGuestStreamDetail,
    getGuestStream: getGuestStream,
    getGuestCompany: getGuestCompany,
    getGuestCompanyProfile: getGuestCompanyProfile,
    changeCommenterType: changeCommenterType,
    getGuestChart: getGuestChart,
    postPollingVote: postPollingVote,
    getGuestUserStream: getGuestUserStream
});


/***/ }),

/***/ 79644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ VerifiedStatus; }
/* harmony export */ });
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/** @typedef {import('axios').AxiosResponse} AxiosResponse */ 
var requestExodus = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
// Configs
var VERIFIED_BADGE_URL = "/verified-badge";
var VERIFIED_BADGE_USER_URL = "".concat(VERIFIED_BADGE_URL, "/user");
/**
 * Get verified badge user
 * @param {Number} userId - userid
 * @return {AxiosResponse}
 */ var getVerifiedBadgeUser = function(userId) {
    return requestExodus.get("".concat(VERIFIED_BADGE_USER_URL, "/").concat(userId));
};
var VerifiedStatus;
(function(VerifiedStatus) {
    VerifiedStatus["VERIFIED_STATUS_UNVERIFIED"] = "VERIFIED_STATUS_UNVERIFIED";
    VerifiedStatus["VERIFIED_STATUS_IDENTITY"] = "VERIFIED_STATUS_IDENTITY";
    VerifiedStatus["VERIFIED_STATUS_COMMUNITY"] = "VERIFIED_STATUS_COMMUNITY";
})(VerifiedStatus || (VerifiedStatus = {}));
// Exports ---------------------------------------------------------------------

/* harmony default export */ __webpack_exports__["Z"] = ({
    getVerifiedBadgeUser: getVerifiedBadgeUser
});


/***/ }),

/***/ 333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ profile; },
  "Sz": function() { return /* binding */ effects; },
  "Cr": function() { return /* binding */ proExpirySelector; },
  "Rd": function() { return /* binding */ profileSelector; },
  "wl": function() { return /* binding */ selectors; }
});

// UNUSED EXPORTS: initialState, userIdSelector

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/lib/api/user.ts
var user = __webpack_require__(1955);
// EXTERNAL MODULE: ./src/lib/api/verifiedBadge.ts
var verifiedBadge = __webpack_require__(79644);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/utils/clevertap.js
var clevertap = __webpack_require__(48028);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./src/lib/models/user/index.js

var schema = {
    id: "",
    username: "",
    fullname: "",
    email: "",
    activated: "",
    banned: "0",
    user_banned_until: "",
    ban_reason: null,
    last_login: "",
    created: "",
    modified: "",
    avatar: "",
    about: "",
    location: "",
    website: "",
    occupation: "",
    gender: "",
    birthday: "",
    phone: "",
    address: "",
    hide_email: "0",
    user_attr: "",
    user_priv: "0",
    tutorial: "0",
    user_newsletter: "",
    country: "ID",
    exchange: "",
    facebook_id: null,
    apple_id: null,
    google_id: null,
    email_subscribe: "",
    user_phone_verification: "",
    facebook_hide: "",
    language: "",
    user_preferences: {},
    user_trading: "",
    user_badge_top: "",
    followed: 0,
    ispro: 0,
    pro_active_since: "",
    pro_expire_at: "",
    tradingpro: 0,
    official: 0,
    trending: 0,
    ir_symbol: "",
    isblocked: 0,
    alert: 0,
    onboarding: 0,
    onboarding_done: 0,
    discover: 0,
    ftcode: "",
    ftend: "",
    realtrading_access: 0,
    top_badge: 0,
    is_term_agreed: 0,
    onesignal_hash: "",
    password: 0,
    support: {
        id: ""
    }
};
var propTypes = {
    id: prop_types.string,
    username: prop_types.string,
    fullname: prop_types.string,
    email: prop_types.string,
    activated: prop_types.string,
    banned: prop_types.string,
    user_banned_until: prop_types.string,
    ban_reason: prop_types.string,
    last_login: prop_types.string,
    created: prop_types.string,
    modified: prop_types.string,
    avatar: prop_types.string,
    about: prop_types.string,
    location: prop_types.string,
    website: prop_types.string,
    occupation: prop_types.string,
    gender: prop_types.string,
    birthday: prop_types.string,
    phone: prop_types.string,
    address: prop_types.string,
    user_attr: prop_types.string,
    user_newsletter: prop_types.string,
    country: prop_types.string,
    exchange: prop_types.string,
    hide_email: prop_types.string,
    user_priv: prop_types.string,
    tutorial: prop_types.string,
    facebook_id: prop_types.string,
    apple_id: prop_types.string,
    google_id: prop_types.string,
    email_subscribe: prop_types.string,
    user_phone_verification: prop_types.string,
    facebook_hide: prop_types.string,
    language: prop_types.string,
    user_preferences: (0,prop_types.oneOfType)([
        prop_types.object,
        prop_types.any
    ]),
    user_trading: prop_types.string,
    user_badge_top: prop_types.string,
    followed: prop_types.number,
    ispro: prop_types.number,
    pro_active_since: prop_types.string,
    pro_expire_at: prop_types.string,
    tradingpro: prop_types.number,
    official: prop_types.number,
    trending: prop_types.number,
    ir_symbol: prop_types.string,
    isblocked: prop_types.number,
    alert: prop_types.number,
    onboarding: prop_types.number,
    onboarding_done: prop_types.number,
    discover: prop_types.number,
    ftcode: prop_types.string,
    ftend: prop_types.string,
    onesignal_hash: prop_types.string,
    realtrading_access: prop_types.number,
    top_badge: prop_types.number,
    is_term_agreed: prop_types.number,
    password: prop_types.number
};
/* harmony default export */ var models_user = ({
    schema: schema,
    propTypes: propTypes
});

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/utils/userResponseMapping.ts



var formatDate = function(date) {
    return moment_default()(date).format("YYYY-MM-DD HH:mm:ss");
};
var userResponseMapping = function(data) {
    var id = data.id, created_at = data.created_at, statistics = data.statistics, profile = data.profile, privilege = data.privilege, exchange = data.exchange, ir_symbols = data.ir_symbols, badges = data.badges, is_alert_enabled = data.is_alert_enabled, is_blocked = data.is_blocked, is_followed = data.is_followed, email = data.email, last_modified_at = data.last_modified_at, last_login_at = data.last_login_at, is_activated = data.is_activated, has_password = data.has_password, is_newsletter_subscriber = data.is_newsletter_subscriber, is_phone_verified = data.is_phone_verified, is_shown_in_discovery = data.is_shown_in_discovery, preferences = data.preferences, onboarding = data.onboarding, free_trial = data.free_trial, sns = data.sns, trading = data.trading, support = data.support, pro = data.pro, ban = data.ban, onesignal_hash = data.onesignal_hash;
    var follower_count = statistics.follower_count, following_count = statistics.following_count, reputation_count = statistics.reputation_count, idea_count = statistics.idea_count, like_count = statistics.like_count, view_count = statistics.view_count;
    var username = profile.username, fullname = profile.fullname, about = profile.about, website = profile.website, avatar = profile.avatar, country = profile.country, language = profile.language, gender = profile.gender, location = profile.location, address = profile.address, birthday = profile.birthday, phone = profile.phone, occupation = profile.occupation;
    var result = {
        id: String(id),
        username: username,
        fullname: fullname,
        email: email,
        activated: is_activated ? "1" : "0",
        banned: String(ban.code),
        user_banned_until: formatDate(ban.until),
        ban_reason: ban.reason === "" ? null : ban.reason,
        last_login: formatDate(last_login_at),
        created: formatDate(created_at),
        modified: formatDate(last_modified_at),
        avatar: avatar.default,
        about: about,
        location: location,
        website: website,
        occupation: occupation,
        gender: gender,
        birthday: birthday,
        phone: phone.formatted,
        address: address,
        hide_email: preferences.privacy.is_hide_email ? "1" : "0",
        // user_attr
        user_priv: String(privilege.code),
        // tutorial
        // user_newsletter
        country: country,
        exchange: exchange,
        facebook_id: sns.facebook_id,
        apple_id: sns.apple_id,
        google_id: sns.google_id,
        email_subscribe: is_newsletter_subscriber ? "1" : "0",
        user_phone_verification: is_phone_verified ? "1" : "0",
        facebook_hide: preferences.privacy.is_hide_facebook ? "1" : "0",
        language: language,
        user_preferences: {
            stream_version: preferences.stream.version
        },
        user_trading: String(trading.account_id),
        // user_badge_top
        additional: {
            reputations: reputation_count,
            followers: String(follower_count),
            ideas: String(idea_count),
            following: String(following_count),
            likes: like_count,
            views: view_count
        },
        followed: is_followed ? 1 : 0,
        ispro: trading.is_pro || pro.is_pro || !moment_default()().isAfter(free_trial.expired_at) ? 1 : 0,
        pro_active_since: formatDate(pro.active_since),
        pro_expire_at: formatDate(pro.expired_at),
        tradingpro: trading.is_pro ? 1 : 0,
        // official
        trending: badges.is_trending ? 1 : 0,
        ir_symbol: ir_symbols,
        isblocked: is_blocked ? 1 : 0,
        alert: is_alert_enabled ? 1 : 0,
        onboarding: onboarding.current_step,
        onboarding_done: onboarding.is_done ? 1 : 0,
        discover: is_shown_in_discovery ? 1 : 0,
        ftcode: free_trial.code,
        ftend: formatDate(free_trial.expired_at),
        realtrading_access: trading.has_realtrading_access ? 1 : 0,
        top_badge: badges.is_top ? 1 : 0,
        // is_term_agreed
        intercom: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, support.intercom), {
            email: support.intercom.email,
            created_at: support.intercom.created_at,
            phone: support.intercom.phone
        }),
        password: has_password ? 1 : 0,
        onesignal_hash: onesignal_hash,
        support: {
            id: support.id
        }
    };
    return result;
};

// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
;// CONCATENATED MODULE: ./src/lib/entities/profile.js







// api
// import { AWS_AVATAR_BUCKET } from 'constants/api';


// Utils


// model



// initial state
var initialState = {
    data: models_user.schema,
    isLoading: true,
    error: null,
    message: "",
    // for flagging btn back is clicked
    isClickedPreviousButton: false,
    connectSocialMedia: {
        data: {},
        isLoading: true,
        error: null,
        message: ""
    }
};
// Selectors -------------------------------------------------------------------
var selectors = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.profile;
}, function(state) {
    return {
        data: state.data,
        isLoading: state.isLoading,
        error: state.error,
        message: state.message,
        isClickedPreviousButton: state.isClickedPreviousButton,
        connectSocialMedia: state.connectSocialMedia
    };
});
var profileSelector = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.profile.data;
}, function(data) {
    return data;
});
var proExpirySelector = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.profile.data;
}, function(data) {
    return data.pro_expire_at;
});
var userIdSelector = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.profile.data.id;
}, function(id) {
    return id;
});
// Actions ---------------------------------------------------------------------
// types
var CONTEXT = "@redux/user";
var actionType = {
    FETCH_PROFILE: "".concat(CONTEXT, "/FETCH_PROFILE"),
    UPDATE_PROFILE: "".concat(CONTEXT, "/UPDATE_PROFILE"),
    CONNECT_SOCIAL_MEDIA: "".concat(CONTEXT, "/CONNECT_SOCIAL_MEDIA"),
    UPDATE_PREFERENCE: "".concat(CONTEXT, "/UPDATE_PREFERENCE")
};
// effects
var effects = {
    // getTrendinguser -------------------------------------------------------------------
    getUserProfile: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.FETCH_PROFILE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(username) {
            var response, _data, data, message, _$error, userId, _$username, email, avatar, responseGetVerifiedBadge, mappedData, isEmitenUser;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return user/* default.getUserProfile */.Z.getUserProfile(username);
                    case 3:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 18;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        userId = data.id ? Number(data.id) : 0;
                        _$username = data.profile && data.profile.username || "";
                        email = data.email || "";
                        avatar = data.profile && data.profile.avatar && data.profile.avatar.default || "";
                        _ctx.next = 12;
                        return verifiedBadge/* default.getVerifiedBadgeUser */.Z.getVerifiedBadgeUser(userId);
                    case 12:
                        responseGetVerifiedBadge = _ctx.sent;
                        if (!_$error) {
                            _ctx.next = 15;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 15:
                        mappedData = userResponseMapping(data);
                        // Clevertap pprofile initialization
                        if (responseGetVerifiedBadge && responseGetVerifiedBadge.data) {
                            isEmitenUser = responseGetVerifiedBadge.data && responseGetVerifiedBadge.data.is_emitten || false;
                            // Track if username is empty
                            if (!_$username) {
                                (0,logger/* default */.ZP)(new Error("[CT initialization Error]: username is empty"), {
                                    place: "src/lib/entities/profile.js",
                                    event: "getUserProfile",
                                    eventParam: {
                                        profile: data.profile
                                    }
                                });
                            }
                            (0,clevertap/* clevertapProfilingUser */.$b)({
                                isInitProfile: true,
                                identity: _$username,
                                email: email,
                                profilePictureUrl: avatar,
                                isEmitenUser: isEmitenUser
                            });
                        }
                        return _ctx.abrupt("return", {
                            data: mappedData,
                            message: message
                        });
                    case 18:
                        throw new Error("Attempt to fetch Trending user Failed");
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    21
                ]
            ]);
        }));
        return function(username) {
            return _ref.apply(this, arguments);
        };
    }()),
    // editUserProfile -------------------------------------------------------------------
    editUserProfile: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.UPDATE_PROFILE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(requestBody) {
            var preventUpdate, body, response, _data, data, message, _$error, sanitizedData, mappedData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        preventUpdate = requestBody.preventUpdate, body = (0,_object_without_properties/* default */.Z)(requestBody, [
                            "preventUpdate"
                        ]);
                        _ctx.next = 4;
                        return user/* default.editUserProfile */.Z.editUserProfile(body);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 12;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        sanitizedData = (0,_object_spread/* default */.Z)({}, data);
                        mappedData = userResponseMapping(data);
                        return _ctx.abrupt("return", {
                            data: mappedData,
                            message: message,
                            preventUpdate: preventUpdate
                        });
                    case 12:
                        throw new Error("Attempt to fetch Trending user Failed");
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    15
                ]
            ]);
        }));
        return function(requestBody) {
            return _ref.apply(this, arguments);
        };
    }()),
    // userConnectSocialMedia -------------------------------------------------------------------
    userConnectSocialMedia: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.CONNECT_SOCIAL_MEDIA, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var socialMediaName, requestBody, dispatch, response, _data, data, message, _$error, userAccess, usernameAuth;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        socialMediaName = param.socialMediaName, requestBody = param.requestBody, dispatch = param1.dispatch;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return user/* default.userConnectSocialMedia */.Z.userConnectSocialMedia(socialMediaName, requestBody);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 13;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        userAccess = auth/* default.getUserAccess */.Z.getUserAccess();
                        usernameAuth = userAccess.username;
                        dispatch(effects.getUserProfile(usernameAuth));
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        throw new Error("Attempt to connect social media Failed");
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    16
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    updatePreference: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.UPDATE_PREFERENCE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(requestData) {
            var response, _data, data, error, error_type, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return user/* default.updatePreference */.Z.updatePreference(requestData);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt update preference failed");
                    case 6:
                        _data = response.data, data = _data.data, error = _data.error, error_type = _data.error_type, message = _data.message;
                        if (!(error || error_type)) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(message);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(requestData) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducer ---------------------------------------------------------------------
var reducers = {
    /**
   * updateOnboardingStep
   * Store back onboarding progress step
   * @param step - object of previous progress step
   * @param isClickedPreviousButton - boolean
   */ updateOnboardingStep: function(draft, action) {
        var step = action.payload.step;
        var newData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, draft.data), {
            onboarding: step
        });
        draft.data = newData;
    },
    /**
   * resetIsClickedPreviousButton
   * change isClickedPreviousButton to false
   */ resetIsClickedPreviousButton: function(draft) {
        draft.isClickedPreviousButton = false;
    },
    /**
   * reset profile state
   */ resetProfileState: function(draft) {
        draft.data = models_user.schema;
    }
};
var _obj;
// Extra Reducer ---------------------------------------------------------------
var extraReducers = (_obj = {}, // Get Userprofile -----------------------------------------------------------
(0,_define_property/* default */.Z)(_obj, effects.getUserProfile.pending, function(state) {
    state.isLoading = true;
}), (0,_define_property/* default */.Z)(_obj, effects.getUserProfile.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.error = error;
    } else {
        state.data = data;
    }
    state.message = message;
    state.isLoading = false;
}), (0,_define_property/* default */.Z)(_obj, effects.getUserProfile.rejected, function(state, action) {
    state.error = action.payload.error;
    state.isLoading = false;
}), // Post editUserProfile -----------------------------------------------------------
// replace state profile
(0,_define_property/* default */.Z)(_obj, effects.editUserProfile.pending, function(state) {
    state.isLoading = true;
}), (0,_define_property/* default */.Z)(_obj, effects.editUserProfile.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error, preventUpdate = _payload.preventUpdate;
    if (error) {
        state.error = error;
    } else {
        // to handle when user has clicked previous button
        // used last onboarding step from state
        // to be used in button next
        var isClickedPreviousButton = state.isClickedPreviousButton;
        var _data = state.data, lastProgress = _data.onboarding;
        var newDataWithLastProgress = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.data), {
            onboarding: lastProgress
        });
        if (!preventUpdate) {
            state.data = isClickedPreviousButton ? newDataWithLastProgress : data;
        }
    }
    state.message = message;
    state.isLoading = false;
}), (0,_define_property/* default */.Z)(_obj, effects.editUserProfile.rejected, function(state, action) {
    state.error = action.payload.error;
    state.isLoading = false;
}), // Post userConnectSocialMedia -----------------------------------------------------------
(0,_define_property/* default */.Z)(_obj, effects.userConnectSocialMedia.pending, function(state) {
    state.connectSocialMedia.isLoading = true;
}), (0,_define_property/* default */.Z)(_obj, effects.userConnectSocialMedia.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.connectSocialMedia.error = error;
    } else {
        state.connectSocialMedia.data = data;
    }
    state.connectSocialMedia.message = message;
    state.connectSocialMedia.isLoading = false;
}), (0,_define_property/* default */.Z)(_obj, effects.userConnectSocialMedia.rejected, function(state, action) {
    state.connectSocialMedia.error = action.payload.error;
    state.connectSocialMedia.isLoading = false;
}), _obj);
// Slice -----------------------------------------------------------------------
var profileSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "profile",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var profile = (profileSlice);


/***/ }),

/***/ 50490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_chat; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/lib/api/chat.ts
var chat = __webpack_require__(69101);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/stores/chat/useGetChatUnreadCount.ts
var useGetChatUnreadCount = __webpack_require__(9986);
;// CONCATENATED MODULE: ./src/stores/chat/message-actions.ts
/* eslint-disable import/no-named-as-default-member */ 









var actions = function(set, get) {
    return {
        fetchMessage: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            return _ctx.abrupt("return", new Promise(function(resolve) {
                                var chatId = params.chatId, roomId = params.roomId, type = params.type, isFetchPrev = params.isFetchPrev, isFetchNext = params.isFetchNext, restParams = (0,_object_without_properties/* default */.Z)(params, [
                                    "chatId",
                                    "roomId",
                                    "type",
                                    "isFetchPrev",
                                    "isFetchNext"
                                ]);
                                if (isFetchPrev) {
                                    set((0,immer_esm/* default */.ZP)(function(state) {
                                        state.conversation.isLoadingPrevMessage = true;
                                    }));
                                } else if (isFetchNext) {
                                    set((0,immer_esm/* default */.ZP)(function(state) {
                                        state.conversation.isLoadingNextMessage = true;
                                    }));
                                } else {
                                    set((0,immer_esm/* default */.ZP)(function(state) {
                                        state.conversation.isLoading = true;
                                    }));
                                }
                                var request = chat/* default.getPersonalMessage */.ZP.getPersonalMessage;
                                switch(type){
                                    case "group":
                                        request = chat/* default.getGroupMessage */.ZP.getGroupMessage;
                                        break;
                                    case "broadcast":
                                        request = chat/* default.getBroadcastMessage */.ZP.getBroadcastMessage;
                                        break;
                                    default:
                                        request = chat/* default.getPersonalMessage */.ZP.getPersonalMessage;
                                }
                                var id = type === "personal" ? chatId : roomId;
                                request(id, restParams).then(function(res) {
                                    var ref;
                                    var data = res.data.data;
                                    var messages = [];
                                    var conversation = get().conversation.messages[chatId];
                                    var prevCursorId = conversation ? conversation === null || conversation === void 0 ? void 0 : (ref = conversation.cursor) === null || ref === void 0 ? void 0 : ref.prev : "";
                                    if (conversation && isFetchPrev) {
                                        messages = (0,_to_consumable_array/* default */.Z)(conversation.messages).concat((0,_to_consumable_array/* default */.Z)(data.messages));
                                    } else if (conversation && isFetchNext) {
                                        messages = (0,_to_consumable_array/* default */.Z)(data.messages).concat((0,_to_consumable_array/* default */.Z)(conversation.messages));
                                    } else {
                                        messages = data.messages;
                                    }
                                    var hasMore = data.is_more;
                                    set((0,immer_esm/* default */.ZP)(function(state) {
                                        var ref;
                                        state.conversation.messages[chatId] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                            cursor: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.cursor), {
                                                prev: isFetchNext ? prevCursorId : data === null || data === void 0 ? void 0 : (ref = data.cursor) === null || ref === void 0 ? void 0 : ref.prev
                                            }),
                                            messages: messages,
                                            is_more: hasMore
                                        });
                                        state.conversation.isLoading = false;
                                        state.conversation.isLoadingPrevMessage = false;
                                        state.conversation.isLoadingNextMessage = false;
                                    }));
                                    resolve(data);
                                }).catch(function() {
                                    set((0,immer_esm/* default */.ZP)(function(state) {
                                        state.conversation.isLoading = false;
                                        state.conversation.isLoadingPrevMessage = false;
                                        state.conversation.isLoadingNextMessage = false;
                                    }));
                                });
                            }));
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(params) {
                return _ref.apply(this, arguments);
            };
        }(),
        pushMessage: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
                var message, chatId, ref, _conversation, localMessages, messages, currentLocalMessage, localMessageIndex, currentMessage, isOnConvo;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            message = params.message, chatId = params.chatId;
                            ref = get(), _conversation = ref.conversation, localMessages = _conversation.localMessages, messages = _conversation.messages;
                            currentLocalMessage = localMessages[chatId];
                            // remove message from local message
                            if (currentLocalMessage) {
                                localMessageIndex = currentLocalMessage.findIndex(function(msg) {
                                    return msg.reference_id === (params === null || params === void 0 ? void 0 : params.reference_id);
                                });
                                if (localMessageIndex > -1) {
                                    set((0,immer_esm/* default */.ZP)(function(state) {
                                        state.conversation.localMessages[chatId].splice(localMessageIndex, 1);
                                    }));
                                }
                            }
                            currentMessage = messages[chatId];
                            // save message to store
                            if (currentMessage) {
                                isOnConvo = currentMessage.messages.some(function(item) {
                                    return item.id === message.id;
                                });
                                if (!isOnConvo) {
                                    set((0,immer_esm/* default */.ZP)(function(state) {
                                        var ref;
                                        state.conversation.messages[chatId].messages.unshift(message);
                                        if ((ref = params.room_status) === null || ref === void 0 ? void 0 : ref.is_mentioned) {
                                            var hasMentioned = currentMessage.mentioned_message_ids;
                                            if (hasMentioned) {
                                                state.conversation.messages[chatId].mentioned_message_ids.push(message === null || message === void 0 ? void 0 : message.id);
                                            } else {
                                                state.conversation.messages[chatId].mentioned_message_ids = [
                                                    message === null || message === void 0 ? void 0 : message.id, 
                                                ];
                                            }
                                        }
                                    }));
                                }
                            } else {
                                set((0,immer_esm/* default */.ZP)(function(state) {
                                    state.conversation.messages[chatId] = {
                                        messages: [
                                            message
                                        ],
                                        cursor: {
                                            prev: "",
                                            next: ""
                                        },
                                        is_more: false,
                                        mentioned_message_ids: []
                                    };
                                }));
                            }
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(params) {
                return _ref.apply(this, arguments);
            };
        }(),
        selectMessage: function(params) {
            var messageId = params.messageId, chatId = params.chatId, checked = params.checked, align = params.align;
            var conversation = get().conversation;
            if (conversation.selected.messageIds.length >= 10 && checked) {
                (0,AlertMessage/* default */.Z)({
                    content: "You can select up to 10 messages",
                    messageType: "error",
                    alertType: "snackbar",
                    hasCloseIcon: true
                });
                return;
            }
            var chatIndex = conversation.messages[chatId].messages.findIndex(function(convo) {
                return convo.id === messageId;
            });
            set((0,immer_esm/* default */.ZP)(function(state) {
                var index = conversation.selected.messageIds.indexOf(messageId);
                if (checked && index < 0) {
                    state.conversation.selected.messageIds.push(messageId);
                    state.conversation.selected.messageAlign.push(align);
                } else if (index >= 0) {
                    state.conversation.selected.messageIds.splice(index, 1);
                    state.conversation.selected.messageAlign.splice(index, 1);
                }
                state.conversation.messages[chatId].messages[chatIndex].selected = checked;
            }));
        },
        cancelSelect: function(params) {
            var chatId = params.chatId;
            set((0,immer_esm/* default */.ZP)(function(state) {
                state.conversation.selected.messageIds = [];
                state.conversation.selected.messageAlign = [];
                state.conversation.messages[chatId].messages = state.conversation.messages[chatId].messages.map(function(message) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, message), {
                        selected: false
                    });
                });
            }));
        },
        doResetSelectedConversation: function() {
            set((0,immer_esm/* default */.ZP)(function(state) {
                state.conversation.selected.messageIds = [];
                state.conversation.selected.messageAlign = [];
            }));
        },
        deleteMessages: function(params) {
            return new Promise(function(resolve, reject) {
                var chatId = params.chatId, messageIds = params.messageIds;
                chat/* default.deleteBulkChatMessage */.ZP.deleteBulkChatMessage(messageIds).then(function(res) {
                    var _data = res.data, data = _data.data, error = _data.error;
                    if (res.status === 200) {
                        var messages = get().conversation.messages[chatId].messages;
                        set((0,immer_esm/* default */.ZP)(function(state) {
                            // eslint-disable-next-line array-callback-return
                            messageIds.map(function(messageId) {
                                var deletedMessageIdx = messages.findIndex(function(message) {
                                    return messageId === message.id;
                                });
                                if (deletedMessageIdx > -1) {
                                    // set flag to deleted
                                    state.conversation.messages[chatId].messages[deletedMessageIdx].body.conversation.flag.is_deleted = true;
                                    // change text message
                                    state.conversation.messages[chatId].messages[deletedMessageIdx].body.conversation.text = "You deleted this message";
                                }
                            });
                        }));
                        resolve(data);
                    } else {
                        reject(error);
                    }
                }).catch(function(error) {
                    reject(error);
                });
            });
        },
        clearMessages: function(chatId) {
            return new Promise(function(resolve, reject) {
                chat/* default.clearChat */.ZP.clearChat(chatId).then(function(res) {
                    var _data = res.data, data = _data.data, error = _data.error;
                    if (data) {
                        set((0,immer_esm/* default */.ZP)(function(state) {
                            state.conversation.messages[chatId] = {
                                cursor: {
                                    prev: "",
                                    next: ""
                                },
                                messages: [],
                                is_more: false,
                                mentioned_message_ids: []
                            };
                        }));
                        resolve(data);
                    } else {
                        reject(error);
                    }
                }).catch(function() {});
            });
        },
        cancelReply: function() {
            set({
                reply: {
                    to_id: 0,
                    visible: false
                }
            });
        },
        replyMessage: function(messageId) {
            set({
                reply: {
                    to_id: messageId,
                    visible: true
                }
            });
        },
        sendMessage: function(params, chatId) {
            return new Promise(function(resolve) {
                chat/* default.sendChatV2 */.ZP.sendChatV2(params).then(function(res) {
                    var _data = res.data, data = _data.data, error = _data.error;
                    if (data) {
                        var message = data.message;
                        get().findAndClearLocalMessages(chatId, params === null || params === void 0 ? void 0 : params.reference_id).then(function() {
                            get().pushMessage({
                                message: message,
                                chatId: chatId,
                                reference_id: params === null || params === void 0 ? void 0 : params.reference_id
                            });
                        });
                        resolve(data);
                    } else {
                        resolve(error);
                    }
                }).catch(function(err) {
                    get().changeLocalMessageStatus(chatId, params.reference_id, "MESSAGE_STATUS_ERROR");
                    resolve(err);
                });
            });
        },
        pushLocalMessage: function(params) {
            if (get().conversation.localMessages[params.data.chatId]) {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.conversation.localMessages[params.data.chatId].push(params);
                }));
            } else {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.conversation.localMessages[params.data.chatId] = [
                        params
                    ];
                }));
            }
        },
        changeLocalMessageStatus: function(chatId, referenceId, status) {
            var localMessageIndex = get().conversation.localMessages[chatId].findIndex(function(msg) {
                return msg.reference_id === referenceId;
            });
            if (localMessageIndex > -1) {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.conversation.localMessages[chatId][localMessageIndex].data.status = status;
                }));
            }
        },
        findAndClearLocalMessages: function(chatId, reference_id) {
            var ref = get(), localMessages = ref.conversation.localMessages;
            return new Promise(function(res, rej) {
                var currentLocalMessage = localMessages[chatId];
                // remove message from local message
                if (currentLocalMessage) {
                    var localMessageIndex = currentLocalMessage.findIndex(function(msg) {
                        return msg.reference_id === reference_id;
                    });
                    if (localMessageIndex > -1) {
                        set((0,immer_esm/* default */.ZP)(function(state) {
                            state.conversation.localMessages[chatId].splice(localMessageIndex, 1);
                        }));
                        res();
                    } else {
                        rej();
                    }
                }
            });
        },
        clearLocalMessages: function(chatId) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                state.conversation.localMessages[chatId] = null;
            }));
        },
        readMessage: function(chatId, roomType) {
            return new Promise(function(resolve) {
                chat/* default.readChat */.ZP.readChat(chatId).then(function(res) {
                    var data = res.data.data;
                    var fetchUnreadCount = useGetChatUnreadCount/* useGetChatUnreadCount.getState */.H.getState().fetchUnreadCount;
                    // update the chat notification counter
                    fetchUnreadCount();
                    set((0,immer_esm/* default */.ZP)(function(state) {
                        var roomIdx = get().rooms[roomType].list.findIndex(// eslint-disable-next-line eqeqeq
                        function(room) {
                            return "".concat(room.id) === "".concat(chatId);
                        });
                        if (roomIdx > -1) {
                            state.rooms[roomType].list[roomIdx].unread_count = 0;
                            state.rooms[roomType].list[roomIdx].status.is_mentioned = false;
                        }
                    }));
                    resolve(data);
                }).catch(function() {});
            });
        },
        readMentionedMessage: function(chatId, messageId) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                var messageIndex = state.conversation.messages[chatId].mentioned_message_ids.findIndex(function(item) {
                    return item === messageId;
                });
                if (messageIndex > -1) {
                    state.conversation.messages[chatId].mentioned_message_ids.splice(messageIndex, 1);
                }
            }));
        },
        forwardMessage: function(params) {
            return new Promise(function(resolve, reject) {
                var chatId = params.chatId, bodyParams = (0,_object_without_properties/* default */.Z)(params, [
                    "chatId"
                ]);
                chat/* default.forwardChat */.ZP.forwardChat(bodyParams).then(function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(res) {
                        var data;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    data = res.data.data;
                                    resolve(data);
                                case 2:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }));
                    return function(res) {
                        return _ref.apply(this, arguments);
                    };
                }()).catch(function(err) {
                    reject(err);
                });
            });
        },
        updateMessageFromWS: function(params) {
            var chatId = params.chatId, messageId = params.messageId, message = params.message;
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (state.conversation.messages[chatId]) {
                    var messageIdx = state.conversation.messages[chatId].messages.findIndex(function(msg) {
                        return msg.id === messageId;
                    });
                    if (messageIdx > -1) {
                        state.conversation.messages[chatId].messages[messageIdx] = message;
                    }
                }
            }));
        }
    };
};
/* harmony default export */ var message_actions = (actions);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
// EXTERNAL MODULE: ./src/utils/chat.js
var utils_chat = __webpack_require__(21779);
;// CONCATENATED MODULE: ./src/stores/chat/room-action.ts
/* eslint-disable import/no-named-as-default-member */ 








var room_action_actions = function(set, get) {
    return {
        fetchDefaultRooms: function(params, sourceToken) {
            return new Promise(function(resolve, reject) {
                var offset = params.offset, _hasLoading = params.hasLoading, hasLoading = _hasLoading === void 0 ? true : _hasLoading;
                set((0,immer_esm/* default */.ZP)(function(state) {
                    if (hasLoading) {
                        if (offset === 0) {
                            state.rooms.default.list = [];
                            state.rooms.default.isLoading = true;
                        } else {
                            state.rooms.default.isLoadingMore = true;
                        }
                    }
                }));
                chat/* default.getRooms */.ZP.getRooms(params, sourceToken).then(function(res) {
                    var _data = res.data, data = _data.data, error = _data.error;
                    set((0,immer_esm/* default */.ZP)(function(state) {
                        if (error) {
                            state.rooms.default.isLoading = false;
                            state.rooms.default.isLoadingMore = false;
                        } else {
                            if (hasLoading && offset !== 0) {
                                var concatRooms = (0,utils_chat/* uniq */.j)(state.rooms.default.list.concat(data.rooms), function(rooms) {
                                    return rooms.id;
                                });
                                state.rooms.default.list = concatRooms;
                            } else {
                                state.rooms.default.list = data.rooms;
                            }
                            state.rooms.default.unreadRequest = data === null || data === void 0 ? void 0 : data.unread_request;
                            state.rooms.default.totalInvited = data === null || data === void 0 ? void 0 : data.total_invited;
                            state.rooms.default.pagination = data === null || data === void 0 ? void 0 : data.pagination;
                        }
                        if (offset === 0) {
                            state.rooms.default.isLoading = false;
                        } else {
                            state.rooms.default.isLoadingMore = false;
                        }
                    }));
                    resolve(data);
                }).catch(function(err) {
                    set((0,immer_esm/* default */.ZP)(function(state) {
                        state.rooms.default.isLoading = false;
                        state.rooms.default.isLoadingMore = false;
                    }));
                    reject(err);
                });
            });
        },
        fetchInvitedRooms: function(params) {
            return new Promise(function(resolve, reject) {
                var offset = params.offset, _hasLoading = params.hasLoading, hasLoading = _hasLoading === void 0 ? true : _hasLoading;
                set((0,immer_esm/* default */.ZP)(function(state) {
                    if (offset === 0 && hasLoading) {
                        state.rooms.invited.list = [];
                        state.rooms.invited.isLoading = true;
                    } else {
                        state.rooms.invited.isLoadingMore = true;
                    }
                }));
                chat/* default.getRequestedRooms */.ZP.getRequestedRooms(params).then(function(res) {
                    var _data = res.data, data = _data.data, error = _data.error;
                    // on message request still using old calculation for pagination is_last_page
                    var pagination = {
                        is_last_page: data.rooms.length < constant/* TOTAL_ROOM_PER_PAGE */.IQ
                    };
                    var requestedData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                        pagination: pagination
                    });
                    set((0,immer_esm/* default */.ZP)(function(state) {
                        if (error) {
                            state.rooms.invited.isLoading = true;
                            state.rooms.default.isLoadingMore = false;
                        } else if (hasLoading && Number(offset) > 0) {
                            var concatRooms = (0,utils_chat/* uniq */.j)(state.rooms.invited.list.concat(data.rooms), function(rooms) {
                                return rooms.id;
                            });
                            state.rooms.invited.list = concatRooms;
                            state.rooms.invited.pagination = pagination;
                        } else {
                            state.rooms.invited.list = data.rooms;
                            state.rooms.invited.pagination = pagination;
                        }
                        if (offset === 0) {
                            state.rooms.invited.isLoading = false;
                        } else {
                            state.rooms.invited.isLoadingMore = false;
                        }
                    }));
                    resolve(requestedData);
                }).catch(function(err) {
                    set((0,immer_esm/* default */.ZP)(function(state) {
                        state.rooms.invited.isLoading = false;
                        state.rooms.invited.isLoadingMore = false;
                    }));
                    reject(err);
                });
            });
        },
        updateRoomListFromWS: function(params) {
            var ref;
            var newChat = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                last_message: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params.last_message), {
                    // prevent missing text attributes on first time chat
                    text: (params === null || params === void 0 ? void 0 : (ref = params.last_message) === null || ref === void 0 ? void 0 : ref.text) || ""
                })
            });
            var isDefaultChat = newChat.state === "ROOM_STATE_ACCEPTED";
            // decide where to place updated chat/room
            // rooms is for private, and requests is for request chat
            var stateBucket = isDefaultChat ? "default" : "invited";
            var rooms = get().rooms;
            var fetchUnreadCount = useGetChatUnreadCount/* useGetChatUnreadCount.getState */.H.getState().fetchUnreadCount;
            var roomIdx = rooms[stateBucket].list.findIndex(function(room) {
                return room.id === newChat.id;
            });
            fetchUnreadCount();
            set((0,immer_esm/* default */.ZP)(function(state) {
                var ref, ref1;
                var isRoomAvail = roomIdx > -1;
                var isUpdateRoomList = (newChat === null || newChat === void 0 ? void 0 : newChat.last_message) !== ((ref1 = (ref = rooms[stateBucket]) === null || ref === void 0 ? void 0 : ref.list[roomIdx]) === null || ref1 === void 0 ? void 0 : ref1.last_message);
                if (isUpdateRoomList) {
                    if (isRoomAvail) {
                        state.rooms[stateBucket].list.splice(roomIdx, 1);
                    }
                    state.rooms[stateBucket].list.unshift(newChat);
                }
            }));
        },
        deleteChatRoom: function(chatId) {
            return new Promise(function(resolve) {
                chat/* default.deleteChatRoom */.ZP.deleteChatRoom(chatId).then(function(res) {
                    var data = res.data.data;
                    var roomId = data.room_id;
                    var defaultRoomsStoreData = get().rooms.default;
                    set((0,immer_esm/* default */.ZP)(function(state) {
                        // remove all data related to `roomId`
                        var roomIdx = defaultRoomsStoreData.list.findIndex(function(room) {
                            return room.id === roomId;
                        });
                        if (roomIdx > -1) {
                            var newChats = (0,_to_consumable_array/* default */.Z)(defaultRoomsStoreData.list);
                            newChats.splice(roomIdx, 1);
                            // rearrange chat list
                            state.rooms.default.list = newChats;
                        }
                        if (state.conversation[roomId]) {
                            delete state.conversation[roomId];
                        }
                    }));
                    resolve(data);
                }).catch(function() {});
            });
        },
        clearLastMessage: function(chatId) {
            var defaultRoomsStoreData = get().rooms.default;
            // remove last message
            var roomIdx = defaultRoomsStoreData.list.findIndex(function(room) {
                return Number(room.id) === Number(chatId);
            });
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (roomIdx > -1) {
                    // update last message text to null
                    state.rooms.default.list = Object.assign([], defaultRoomsStoreData.list, (0,_define_property/* default */.Z)({}, roomIdx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultRoomsStoreData.list[roomIdx]), {
                        last_message: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultRoomsStoreData.list[roomIdx].last_message), {
                            text: "",
                            sender_username: "",
                            type: "ATTACHMENT_TYPE_UNSPECIFIED",
                            is_deleted: false,
                            id: 0
                        })
                    })));
                }
            }));
        }
    };
};
/* harmony default export */ var room_action = (room_action_actions);

;// CONCATENATED MODULE: ./src/stores/chat/index.ts





var initialState = {
    conversation: {
        messages: {},
        localMessages: {},
        selected: {
            messageIds: [],
            messageAlign: []
        },
        isLoading: false,
        isLoadingPrevMessage: false,
        isLoadingNextMessage: false
    },
    rooms: {
        default: {
            list: [],
            totalInvited: 0,
            unreadRequest: 0,
            isLoading: false,
            isLoadingMore: false,
            pagination: {
                is_last_page: false
            }
        },
        invited: {
            list: [],
            isLoading: false,
            isLoadingMore: false,
            pagination: {
                is_last_page: false
            }
        }
    },
    reply: {
        to_id: 0,
        visible: false
    }
};
var useChatStore = (0,esm/* default */.ZP)(function() {
    for(var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++){
        arg[_key] = arguments[_key];
    }
    return (0,_object_spread/* default */.Z)({}, initialState, message_actions.apply(void 0, (0,_to_consumable_array/* default */.Z)(arg)), room_action.apply(void 0, (0,_to_consumable_array/* default */.Z)(arg)));
});
/* harmony default export */ var stores_chat = (useChatStore);


/***/ }),

/***/ 9986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useGetChatUnreadCount; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand_middleware_immer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42435);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38597);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var lib_api_chat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69101);








var initialState = {
    count: 0,
    hasNewMessage: false,
    isReset: false
};
var useGetChatUnreadCount = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_3__/* .persist */ .tJ)((0,zustand_middleware_immer__WEBPACK_IMPORTED_MODULE_4__/* .immer */ .n)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, initialState), {
        resetCounter: function resetCounter() {
            set({
                count: 0,
                hasNewMessage: false,
                isReset: true
            });
        },
        fetchUnreadCount: function fetchUnreadCount() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return lib_api_chat__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getUnreadCount */ .ZP.getUnreadCount();
                        case 2:
                            response = _ctx.sent;
                            data = response.data.data;
                            set(function(draft) {
                                draft.count = data.count;
                                draft.hasNewMessage = data.has_new_message;
                                draft.isReset = false;
                            });
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        }
    });
}), {
    name: "notifChatCounter"
}));


/***/ }),

/***/ 14601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HM": function() { return /* binding */ isReadMoreShow; },
/* harmony export */   "Hm": function() { return /* binding */ cleanupStreamPayload; },
/* harmony export */   "Nk": function() { return /* binding */ parseExistImage; },
/* harmony export */   "P9": function() { return /* binding */ getYoutubeVideoId; },
/* harmony export */   "PI": function() { return /* binding */ transformConversationV3; },
/* harmony export */   "Zu": function() { return /* binding */ getYoutubeURL; },
/* harmony export */   "bv": function() { return /* binding */ transformV3Response; },
/* harmony export */   "hp": function() { return /* binding */ transformStreamV3; },
/* harmony export */   "qm": function() { return /* binding */ parseEmoji; },
/* harmony export */   "vO": function() { return /* binding */ parseStreamPostContent; }
/* harmony export */ });
/* unused harmony export countWords */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36305);
/* harmony import */ var global_StreamCompose_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79030);
/* eslint-disable prefer-destructuring */ /* eslint-disable no-useless-escape */ /* eslint-disable import/prefer-default-export */ 




/**
 * Function to parse post content to data which can be read in
 * component `StreamCompose`
 * @param {Object} post - Post object
 * @return {Object} parsed post
 */ var parseEmoji = function(textContent) {
    return textContent;
};
var parseStreamPostContent = function(post) {
    var content = post.content_original, images = post.images, imagesData = post.images_data, attachment = post.attachment, targetPrice = post.target_price, commenterType = post.commenter_type, postId = post.postid, parentPostId = post.parent_postid;
    var parsedContent = {
        content: parseEmoji(content),
        images: images,
        images_data: imagesData,
        documents: attachment || [],
        targetPrice: null,
        commenter_type: commenterType,
        postId: postId,
        parentPostId: parentPostId
    };
    if ((targetPrice === null || targetPrice === void 0 ? void 0 : targetPrice.length) > 0) {
        parsedContent.targetPrice = {
            target_duration: targetPrice[0].duration,
            target_price: targetPrice[0].target_price,
            target_symbol: targetPrice[0].symbol
        };
    }
    // Polling is not included to parsed content since polling is not editable
    return parsedContent;
};
/**
 * Get last Youtube url from user content
 * @param {string} contentOriginal - original content from stream post
 */ function getYoutubeURL() {
    var contentOriginal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var exp = /((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?/gm;
    var list = contentOriginal.match(exp);
    if (list && list.length >= 1) {
        return list[list.length - 1];
    }
    return null;
}
/**
 * parse youtube video URL
 * @param {string} youtubeURL - URL of youtube video
 */ function parseYoutubeURL() {
    var youtubeURL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var exp = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]{1,50}\?v=|embed\/|v\/|e\/|live\/|shorts\/)?)([\w\-]{11})(\S+)?$/gm;
    var list = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(youtubeURL.matchAll(exp)).map(function(m) {
        return {
            url: m[0],
            protocol: m[1],
            www: m[2],
            host: m[3],
            slug: m[4],
            id: m[5],
            params: m[6]
        };
    });
    return list.length === 1 ? list[0] : null;
}
/**
 * Get youtube video ID from youtube URL
 * @param {string} youtubeURL - URL of youtube video
 */ function getYoutubeVideoId() {
    var youtubeURL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref;
    return youtubeURL ? (ref = parseYoutubeURL(youtubeURL)) === null || ref === void 0 ? void 0 : ref.id : null;
}
/**
 * Count words from escaped string
 * @param {string} str
 * @returns {number} words length
 */ var countWords = function(str) {
    var newStr = str.trim();
    newStr = newStr.replace(/[ ]{2,}/gi, " ");
    newStr = newStr.replace(/\n /, "\n");
    return newStr.split(/\s+/).length;
};
var MAX_WORDS = 10;
var MAX_NEWLINE = 2;
/**
 * Decide to show read more flag
 * @param {string} contentOriginal - Original content
 * @param {number=} maxWords - Maximum words
 * @param {number=} maxNewLine - Max paragraph
 * @returns {boolean}
 */ var isReadMoreShow = function() {
    var contentOriginal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", maxWords = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : MAX_WORDS, maxNewLine = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : MAX_NEWLINE;
    return countWords(contentOriginal) > maxWords || contentOriginal.split(/\r\n|\r|\n/).length > maxNewLine;
};
/**
 * Parse Etension from Url
 * @param {string} unparsedUrl - url file string
 * @returns {string} - file extension from the url
 */ var parseExtension = function(unparsedUrl) {
    // Remove everything to the last slash in URL
    var url = unparsedUrl.substr(1 + unparsedUrl.lastIndexOf("/"));
    // Break URL at ? and take first part (file name, extension)
    url = url.split("?")[0];
    // Sometimes URL doesn't have ? but #, so we should aslo do the same for #
    url = url.split("#")[0];
    // Now we have only extension
    url = url.split(".").pop();
    return url;
};
/**
 * Parse Images Data Json to parsed Format
 * @param {Array} images - images_data JSON response from api
 * @returns {Array}
 */ var parseExistImage = function(images) {
    var parsedImages = images.map(function(image) {
        return {
            dimensions: {
                width: image.width,
                height: image.height
            },
            imagePreviewUrl: image.image,
            file: image.image,
            isNew: false,
            type: parseExtension(image.image).toLowerCase() === "gif" ? global_StreamCompose_constants__WEBPACK_IMPORTED_MODULE_0__/* .IMAGE_TYPE_GIF */ .p$ : global_StreamCompose_constants__WEBPACK_IMPORTED_MODULE_0__/* .IMAGE_TYPE_COMMON */ .EZ
        };
    });
    return parsedImages;
};
/**
 * Convert stream V3 response to stream V2 response
 * @param {Object} stream - stream V3 response
 * @returns {Object} stream V2 response
 */ function transformStreamV3() {
    var stream = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1;
    if (!stream) {
        return stream;
    }
    var UserRole = {
        PRIVILEGE_MEMBER: 0,
        PRIVILEGE_ADMIN: 1,
        PRIVILEGE_MODERATOR: 2,
        PRIVILEGE_CONFIGURATOR: 3,
        PRIVILEGE_SUPER_ADMIN: 4
    };
    var CountryID = {
        COUNTRY_ID: "ID",
        COUNTRY_MY: "MY",
        COUNTRY_SG: "SG"
    };
    var transformBoolean = function(status) {
        return status ? 1 : 0;
    };
    var transformed = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, stream, stream.status, stream.user), {
        country: CountryID[stream.user.country],
        created: stream.created_at,
        follow: transformBoolean(stream.status.is_followed),
        is_author: transformBoolean(stream.user.is_author),
        is_unavailable: stream.status.is_unavailable,
        isnews: transformBoolean(stream.title_url),
        ispinned: transformBoolean(stream.status.is_pinned),
        ispro: transformBoolean(stream.user.is_pro),
        liked: transformBoolean(stream.status.is_liked),
        likes: stream.total_likes,
        newsfeed_img: stream.news_feed.img,
        newsfeed_label: stream.news_feed.label,
        newsfeed_source: stream.news_feed.source,
        official: transformBoolean(stream.user.is_verified),
        parent_postid: stream.parent_stream_id,
        postid: stream.stream_id,
        replies: stream.total_replies.toString(),
        replying_to: transformBoolean(stream.reply_to),
        replyto: stream.reply_to.toString(),
        reposted: transformBoolean(stream.status.is_reposted),
        repostedfrom: transformStreamV3(stream.reposted_from),
        saved: transformBoolean(stream.status.is_saved),
        titleurl: stream.title_url,
        trending: transformBoolean(stream.status.is_trending),
        updated: stream.updated_at,
        user_priv: UserRole[stream.user.user_privilege],
        userid: stream.user.user_id,
        isJunk: Boolean((ref = stream.status) === null || ref === void 0 ? void 0 : ref.is_junk),
        isSpam: Boolean((ref1 = stream.status) === null || ref1 === void 0 ? void 0 : ref1.is_spam)
    });
    if (transformed.last_reply && transformed.last_reply.user) {
        transformed.last_reply = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, transformed.last_reply, transformed.last_reply.user), {
            postid: transformed.last_reply.stream_id
        });
        delete transformed.last_reply.user;
    }
    if (transformed.reply_content) {
        transformed.reply_content = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, transformed.reply_content), {
            titleurl: transformed.reply_content.title_url
        });
        delete transformed.reply_content.title_url;
    }
    delete transformed.user;
    delete transformed.status;
    return transformed;
}
/**
 * Convert stream V3 response to stream V2 response
 * @param {Array} streamList - stream V3 response
 * @returns {Array} stream V2 response
 */ function transformV3Response() {
    var streamList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (!streamList) {
        return streamList;
    }
    return streamList.map(transformStreamV3);
}
function transformConversationV3() {
    var conversation = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!conversation) {
        return conversation;
    }
    var payload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, conversation), {
        parent: transformStreamV3(conversation.parent),
        replies: transformV3Response(conversation.replies)
    });
    return payload;
}
/**
 * Remove empty value from object
 * @param {Object} obj
 * @returns {Object}
 * @example
 * const obj = {
 *  a: '',
 * b: null,
 * c: undefined,
 * d: 'd',
 * }
 * cleanupStreamPayload(obj) // { d: 'd' }
 */ function cleanupStreamPayload(obj) {
    return Object.fromEntries(Object.entries(obj).filter(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(param, 2), value = _param[1];
        return value !== "" && value !== null && value !== undefined;
    }));
}



/***/ })

}]);